<script>

import {FormWizard, TabContent} from "vue3-form-wizard";
import "vue3-form-wizard/dist/style.css";

import {useVuelidate} from '@vuelidate/core'
import {helpers, required, requiredIf} from '@vuelidate/validators'

import dropZone2Component from "./subcomponents/dropZone2Component"
import mobileNumberInput from "./subcomponents/mobileNumberInput"
import coPaymentInputs from "./subcomponents/coPaymentInputs"

import {api as viewerApi} from "v-viewer"

export default {
  inject: ['$Q', '$DateTime', '$axios', '$_'],
  emits: ["dirtLists"],
  props: {draftProfileTs: String, returnedProfile: Boolean},
  setup() {
    return {v$: useVuelidate()}
  },
  data() {
    return {
      navigationBlockedByCaseId: false,
      fetchingCaseId: false,
      updateNumber: 0,
      validationHasOccured: false,
      draftResp: false,
      profileSubmitted: false,
      profileSubmittedMsg: '',
      currentDataLoaded: false,
      trueBool: true,
      disablePrivacyReason: true,
      leavingTab: 0,
      enteringTab: 0,
      locationsReturned: [],
      surgeriesReturned: [],
      locationPicked: true,
      surgeryPicked: true,
      relationshipsReturned: {fetchNokRelations: [], fetchGuardianRelations: []},
      relationPicked: {fetchNokRelations: true, fetchGuardianRelations: true},
      showErrors: [false, false, false],
      districtEnabled: true,
      locationSearchStatus: false,
      surgerySearchStatus: false,
      relationshipSearchStatus: {fetchNokRelations: false, fetchGuardianRelations: false},
      patientProfile: {
        profileTS: '',
        caseIdFinder: '',
        patientInfo: {
          name: '',
          dob: '',
          gender: '',
          marital: '',
          education: '',
          phoneNumber: '',
          phoneNumberPrefix: '',
          documentNumber: '',
          documentType: '',
          guardianName: '',
          guardianDocumentType: '',
          guardianDocumentNumber: '',
          guardianPhone: '',
          guardianPhonePrefix: '',
          guardianRelation: '',
          guardianIsNok: false,
          inpatientNumber: '',
          patientType: '',
          nok: '',
          nokPhone: '',
          nokPhonePrefix: '',
          nokRelation: '',
          patientLocation: '',
          patientDistrict: '',
          closestHealthCenter: '',
          referralFrom: '',
          healthInsurance: '',
          patientDescriptor: '',
          patientPrivacy: '',
          patientPrivacyReason: '',
        },
        socialEconomic: {
          ageGroup: '',
          profile: '',
          profileDetails: '',
          employmentForm: '',
          employmentFormDetails: '',
          monthlyIncome: '',
          housingType: '',
          housingTypeOther: '',
          houseRooms: '',
          houseRoomsOther: '',
          lightingEnergy: '',
          lightingEnergyOther: '',
          cookingEnergy: '',
          cookingEnergyOther: '',
        },
        family: {
          householdSupported: '',
          householdSupportedDetails: '',
          childrenCount: ''
        },
        illnessProfile: {
          surgeryType: '',
          condition: '',
          surgeryRequired: '',
          coordinatorNotified: '',
          coordinatorNotifiedMeans: '',
          safeAskAmount: '-',
          isCoPaying: false,
          surgeryId: '',
          gravidity: '',
          parity: '',
          autoApprove: false,
          autoApprovePocket: '',
          lengthOfCondition: '',
          lengthOfConditionUnit: '',
          estDateOfSurgery: '',
          coPaymentOOPCurrency: 'USD',
          coPaymentOOPAmount: '',
          coPaymentInsCurrency: 'USD',
          coPaymentInsAmount: '',
          insuranceProvider: '',
          transportation: '',
          transportationOther: '',
          transportationCost: '',
          timeToHospital: '',
          timeToHospitalUnits: '',
          patientStory: '',
          patientQuote: '',
        },
        confirmation: {
          faceOne: '',
          faceTwo: '',
          conditionOne: '',
          conditionTwo: '',
          IDFront: '',
          IDBack: '',
          PassportBio: '',
          DLFace: '',
          waiverFile: '',
          profileAttachment_1: '',
          profileAttachment_2: '',
          profileAttachment_3: '',
          treatmentchangelife: '',
          treatmentupdate: '',
        },
        dropzone2Trigger: '',
        returnedObjs: []
      },
      patientProfileIdentifier: '',
      summaryProfile: {},
      patientProfileFromDraft: false,
      surgeryHasGravidity: false,
      surgeryHasParity: false,
      // surgeryWillAutoApprove: false,
      memberAgeNumber: '-',
      memberAgeUnits: '',
      surgeryDateDiffDays: '-',
      ageGroupName: '-',
      guardianText: 'patient',
      adultBool: true,
      nokBool: true,
      GPSExifLocationKeys: ['GPSLatitudeRef', 'GPSLatitude',
        'GPSLongitudeRef', 'GPSLongitude'],
      GPSExifKeys: [
        'GPSVersionID', 'GPSLatitudeRef', 'GPSLatitude',
        'GPSLongitudeRef', 'GPSLongitude', 'GPSAltitudeRef',
        'GPSAltitude', 'GPSTimeStamp', 'GPSSatellites',
        'GPSStatus', 'GPSMeasureMode', 'GPSDOP',
        'GPSSpeedRef', 'GPSSpeed', 'GPSTrackRef',
        'GPSTrack', 'GPSImgDirectionRef', 'GPSImgDirection',
        'GPSMapDatum', 'GPSDestLatitudeRef', 'GPSDestLatitude',
        'GPSDestLongitudeRef', 'GPSDestLongitude', 'GPSDestBearingRef',
        'GPSDestBearing', 'GPSDestDistanceRef', 'GPSDestDistance',
        'GPSProcessingMethod', 'GPSAreaInformation', 'GPSDateStamp',
        'GPSDifferential', 'GPSHPositioningError', 'GPSInfoIFDPointer'],
      DateTimeExifKeys: ['DateTime', 'DateTimeOriginal', 'DateTimeDigitized'],
      localDirtyList: [],
    }
  },
  validations() {
    let vm = this;
    return {
      patientProfile: {
        patientInfo: {
          name: {required: helpers.withMessage("{Personal Tab} Please provide the patient's name", required)},
          dob: {required: helpers.withMessage("{Personal Tab} Please provide the patient's date of birth", required)},
          gender: {required: helpers.withMessage("{Personal Tab} Please provide the patient's gender", required)},
          patientType: {required: helpers.withMessage("{Personal Tab} Please provide the patient type", required)},
          marital: {required: helpers.withMessage("{Personal Tab} Please provide the patient's marital status", required)},
          education: {required: helpers.withMessage("{Personal Tab} Please provide the patient's education level", required)},
          patientDescriptor: {required: helpers.withMessage("{Personal Tab} Please provide the patient's description", required)},
          healthInsurance: {required: helpers.withMessage("{Personal Tab} Please specify if the patient has health insurance", required)},
          phoneNumber: {requiredIfAdult: helpers.withMessage("{Personal Tab} Please provide the phone number", requiredIf(vm.adultBool))},
          phoneNumberPrefix: {requiredIfAdult: helpers.withMessage("{Personal Tab} Please provide the phone number prefix", requiredIf(vm.adultBool))},
          documentType: {requiredIfAdult: helpers.withMessage("{Personal Tab} Please select the identification document type", requiredIf(vm.adultBool))},
          documentNumber: {requiredIfAdult: helpers.withMessage("{Personal Tab} Please provide the identification document number", requiredIf(vm.adultBool))},
          guardianName: {requiredIfNotAdult: helpers.withMessage("{Personal Tab} Please provide the guardian's name", requiredIf(!vm.adultBool))},
          guardianDocumentType: {requiredIfNotAdult: helpers.withMessage("{Personal Tab} Please provide the guardian's document type", requiredIf(!vm.adultBool))},
          guardianDocumentNumber: {requiredIfNotAdult: helpers.withMessage("{Personal Tab} Please provide the guardian's document number", requiredIf(!vm.adultBool))},
          guardianPhone: {requiredIfNotAdult: helpers.withMessage("{Personal Tab} Please provide the guardian's phone number", requiredIf(!vm.adultBool))},
          guardianPhonePrefix: {requiredIfNotAdult: helpers.withMessage("{Personal Tab} Please provide the guardian's phone number prefix", requiredIf(!vm.adultBool))},
          guardianRelation: {requiredIfNotAdult: helpers.withMessage("{Personal Tab} Please provide the guardian's relation", requiredIf(!vm.adultBool))},
          nok: {requiredIfAdultOrMinorWithDifferentNok: helpers.withMessage("{Personal Tab} Please provide the next of kin's name", requiredIf(vm.adultBool || vm.isMinorWithDifferentNok))},
          nokPhone: {requiredIfAdultOrMinorWithDifferentNok: helpers.withMessage("{Personal Tab} Please provide the next of kin's phone number", requiredIf(vm.adultBool || vm.isMinorWithDifferentNok))},
          nokPhonePrefix: {requiredIfAdultOrMinorWithDifferentNok: helpers.withMessage("{Personal Tab} Please provide the next of kin's phone number prefix", requiredIf(vm.adultBool || vm.isMinorWithDifferentNok))},
          nokRelation: {requiredIfAdultOrMinorWithDifferentNok: helpers.withMessage("{Personal Tab} Please provide the next of kin's relation", requiredIf(vm.adultBool || vm.isMinorWithDifferentNok))},
          patientLocation: {required: helpers.withMessage("{Personal Tab} Please provide the patient's location", required)},
          patientDistrict: {required: helpers.withMessage("{Personal Tab} Please provide the patient's district", required)},
          closestHealthCenter: {required: helpers.withMessage("{Personal Tab} Please specify the patient's closest health center", required)},
          referralFrom: {required: helpers.withMessage("{Personal Tab} Please specify where the patient was referred from", required)},
          patientPrivacy: {required: helpers.withMessage("{Personal Tab} Please select the patient's privacy preference", required)},
          patientPrivacyReason: {requiredIfPrivacyRequested: helpers.withMessage("{Personal Tab} Please select the patient's reason for privacy", requiredIf(vm.patientProfile.patientInfo.patientPrivacy === 'privacyyes'))},
        },
        socialEconomic: {
          profile: {required: helpers.withMessage("{Personal Tab} Please select the patient's employment profile", required)},
          profileDetails: {requiredIfSelfEmployed: helpers.withMessage("{Personal Tab} Please provide the patient's self employment description", requiredIf(vm.patientProfile.socialEconomic.profile === 'patientselfemployed'))},
          employmentForm: {requiredIfEmployed: helpers.withMessage("{Personal Tab} Please select the patient's employment type", requiredIf(vm.patientProfile.socialEconomic.profile === 'patientemployed'))},
          employmentFormDetails: {requiredIfEmployed: helpers.withMessage("{Personal Tab} Please provide the patient's employment description", requiredIf(vm.patientProfile.socialEconomic.profile === 'patientemployed'))},
          monthlyIncome: {requiredIfEmployed: helpers.withMessage("{Personal Tab} Please select the patient's monthly income", requiredIf(vm.hasSomeFormOfEmployment))},
          housingType: {required: helpers.withMessage("{Personal Tab} Please select the patient's housing type", required)},
          housingTypeOther: {requiredIfOtherHousingType: helpers.withMessage("{Personal Tab} Please specify the patient's housing type", requiredIf(vm.patientProfile.socialEconomic.housingType === 'typeofhousingother'))},
          houseRooms: {required: helpers.withMessage("{Personal Tab} Please select the number of rooms", required)},
          houseRoomsOther: {requiredIfRoomsThreePlus: helpers.withMessage("{Personal Tab} Please specify the number of rooms", requiredIf(vm.patientProfile.socialEconomic.houseRooms === 'numberofroomsthreeplus'))},
          lightingEnergy: {required: helpers.withMessage("{Personal Tab} Please select the main source of energy for lighting", required)},
          lightingEnergyOther: {requiredIfLightEnergyOther: helpers.withMessage("{Personal Tab} Please specify the main source of energy for lighting", requiredIf(vm.patientProfile.socialEconomic.lightingEnergy === 'mainsourceoflightingother'))},
          cookingEnergy: {required: helpers.withMessage("{Personal Tab} Please select the main source of energy for cooking", required)},
          cookingEnergyOther: {requiredIfCookingEnergyOther: helpers.withMessage("{Personal Tab} Please specify the main source of energy for cooking", requiredIf(vm.patientProfile.socialEconomic.cookingEnergy === 'mainsourceofcookingother'))},
        },
        family: {
          householdSupported: {required: helpers.withMessage("{Personal Tab} Please select the number of household members supported", required)},
          householdSupportedDetails: {requiredIfSupportingOverTen: helpers.withMessage("{Personal Tab} Please specify the number of household members supported", requiredIf(vm.patientProfile.family.householdSupported === 'numberofdependantsother'))},
          childrenCount: {required: helpers.withMessage("{Personal Tab} Please select the number of children", required)},
        },
        illnessProfile: {
          surgeryType: {required: helpers.withMessage("{Illness Tab} Please select the surgery type", required)},
          condition: {required: helpers.withMessage("{Illness Tab} Please specify the condition", required)},
          surgeryRequired: {required: helpers.withMessage("{Illness Tab} Please select the surgery required", required)},
          coordinatorNotified: {requiredIfTypeIsEmergency: helpers.withMessage("{Illness Tab} Please specify if the coordinator was notified", requiredIf(vm.patientProfile.illnessProfile.surgeryType === 'surgerytypeemergency'))},
          coordinatorNotifiedMeans: {requiredIfCoordinatorWasNotified: helpers.withMessage("{Illness Tab} Please specify how the coordinator was notified", requiredIf(vm.patientProfile.illnessProfile.coordinatorNotified === 'coordinatornotifiedyes'))},
          coPaymentOOPAmount: {requiredIfCopaySelectedAndOOPEmpty: helpers.withMessage("{Illness Tab} Please specify the co-payment amount", requiredIf(vm.copaymentRequired))},
          coPaymentInsAmount: {requiredIfCopaySelectedAndInsEmpty: helpers.withMessage("{Illness Tab} Please specify the co-payment amount", requiredIf(vm.copaymentRequired))},
          insuranceProvider: {requiredIfInsuranceCopay: helpers.withMessage("{Illness Tab} Please specify the insurance provider", requiredIf(vm.patientProfile.illnessProfile.coPaymentInsAmount > 0))},
          gravidity: {requiredIfSurgeryHasGravidity: helpers.withMessage("{Illness Tab} Please provide the gravidity", requiredIf(vm.surgeryHasGravidity))},
          parity: {requiredIfSurgeryHasParity: helpers.withMessage("{Illness Tab} Please provide the parity", requiredIf(vm.surgeryHasParity))},
          lengthOfCondition: {required: helpers.withMessage("{Illness Tab} Please specify how long the patient has had the condition", required)},
          lengthOfConditionUnit: {required: helpers.withMessage("{Illness Tab} Please select the measure of how long the patient has had the condition", required)},
          estDateOfSurgery: {required: helpers.withMessage("{Illness Tab} Please specify the estimated date of surgery", required)},
          transportation: {required: helpers.withMessage("{Illness Tab} Please select the mode of transport to get to hospital", required)},
          transportationOther: {requiredIfTransportationOther: helpers.withMessage("{Illness Tab} Please specify the mode of transport to get to hospital", requiredIf(vm.patientProfile.illnessProfile.transportation === 'modeoftransporttohospitalother'))},
          transportationCost: {required: helpers.withMessage("{Illness Tab} Please select the cost of transport used", required)},
          timeToHospital: {required: helpers.withMessage("{Illness Tab} Please specify the time taken to get to hospital", required)},
          timeToHospitalUnits: {required: helpers.withMessage("{Illness Tab} Please select the measure of the time taken to get to hospital", required)},
          patientStory: {required: helpers.withMessage("{Illness Tab} Please provide the patient story", required)},
          patientQuote: {required: helpers.withMessage("{Illness Tab} Please provide the patient quote", required)},
        },
        confirmation: {
          faceOne: {required: helpers.withMessage("{Attachments Tab} Please provide the 1st photo of the patient's pre-OP", required)},
          faceTwo: {required: helpers.withMessage("{Attachments Tab} Please provide the 2nd photo of the patient's pre-OP", required)},
          waiverFile: {required: helpers.withMessage("{Attachments Tab} Please provide the patient signed waiver", required)},
          treatmentchangelife: {required: helpers.withMessage("{Attachments Tab} Please select if the treatement will improve the patient's quality of life", required)},
          treatmentupdate: {required: helpers.withMessage("{Attachments Tab} Please select if you commit to provide a complete update of the patient", required)},
        }
      }
    }
  },
  components: {
    FormWizard,
    TabContent,
    dropZone2Component,
    mobileNumberInput,
    coPaymentInputs
  },
  methods: {
    closeProfileForm: function () {
      let vm = this;
      vm.$emit('profileSaved');
    },
    ResetProfileForm: function () {
      let vm = this;
      vm.patientProfile = {
        profileTS: '',
        caseIdFinder: '',
        patientInfo: {
          name: '',
          dob: '',
          gender: '',
          marital: '',
          education: '',
          phoneNumber: '',
          phoneNumberPrefix: '',
          documentNumber: '',
          documentType: '',
          guardianName: '',
          guardianDocumentType: '',
          guardianDocumentNumber: '',
          guardianPhone: '',
          guardianPhonePrefix: '',
          guardianRelation: '',
          guardianIsNok: false,
          inpatientNumber: '',
          nok: '',
          nokPhone: '',
          nokPhonePrefix: '',
          nokRelation: '',
          patientLocation: '',
          patientDistrict: '',
          closestHealthCenter: '',
          referralFrom: '',
          healthInsurance: '',
          patientDescriptor: '',
          patientPrivacy: '',
          patientPrivacyReason: '',
        },
        socialEconomic: {
          ageGroup: '',
          profile: '',
          profileDetails: '',
          employmentForm: '',
          employmentFormDetails: '',
          monthlyIncome: '',
          housingType: '',
          housingTypeOther: '',
          houseRooms: '',
          houseRoomsOther: '',
          lightingEnergy: '',
          lightingEnergyOther: '',
          cookingEnergy: '',
          cookingEnergyOther: '',
        },
        family: {
          householdSupported: '',
          householdSupportedDetails: '',
          childrenCount: ''
        },
        illnessProfile: {
          surgeryType: '',
          condition: '',
          surgeryRequired: '',
          safeAskAmount: '-',
          isCoPaying: false,
          gravidity: '',
          parity: '',
          lengthOfCondition: '',
          lengthOfConditionUnit: '',
          estDateOfSurgery: '',
          coPaymentOOPCurrency: 'USD',
          coPaymentOOPAmount: '',
          coPaymentInsCurrency: 'USD',
          coPaymentInsAmount: '',
          insuranceProvider: '',
          transportation: '',
          transportationOther: '',
          transportationCost: '',
          timeToHospital: '',
          timeToHospitalUnits: '',
          patientStory: '',
          patientQuote: '',
        },
        confirmation: {
          faceOne: '',
          faceTwo: '',
          conditionOne: '',
          conditionTwo: '',
          IDFront: '',
          IDBack: '',
          PassportBio: '',
          DLFace: '',
          waiverFile: '',
          profileAttachment_1: '',
          profileAttachment_2: '',
          profileAttachment_3: '',
          treatmentchangelife: '',
          treatmentupdate: '',
        },
        dropzone2Trigger: ''
      };
      vm.patientProfileFromDraft = false;
      localStorage.removeItem("draftprofile");
      vm.validateForm();
    },
    wholeNumbersOnly(event) {
      let charCode = (event.which) ? event.which : event.keyCode;
      if ((charCode >= 48 && charCode <= 57) || charCode === 8 || charCode === 127) {
        return true;
      } else {
        event.preventDefault();
      }
    },
    noNegativeValues(numberProvidedField) {
      let vm = this,
          numberProvided
      switch (numberProvidedField) {
        case 'houseRoomsOther':
          numberProvided = vm.patientProfile.socialEconomic.houseRoomsOther;
          break;
        case 'householdSupportedDetails':
          numberProvided = vm.patientProfile.family.householdSupportedDetails;
          break;
        case 'childrenCount':
          numberProvided = vm.patientProfile.family.childrenCount;
          break;
        case 'lengthOfCondition':
          numberProvided = vm.patientProfile.illnessProfile.lengthOfCondition;
          break;
        case 'gravidity':
          numberProvided = vm.patientProfile.illnessProfile.gravidity;
          break;
        case 'parity':
          numberProvided = vm.patientProfile.illnessProfile.parity;
          break;
        case 'timeToHospital':
          numberProvided = vm.patientProfile.illnessProfile.timeToHospital;
          break;
      }
      const numberProvidedRounded = Math.round(Number(numberProvided))
      let numberProvidedRoundedAccepted = numberProvidedRounded
      if (numberProvidedRounded <= 0) {
        numberProvidedRoundedAccepted = 0
      }
      switch (numberProvidedField) {
        case 'houseRoomsOther':
          vm.patientProfile.socialEconomic.houseRoomsOther = numberProvidedRoundedAccepted;
          break;
        case 'householdSupportedDetails':
          vm.patientProfile.family.householdSupportedDetails = numberProvidedRoundedAccepted;
          break;
        case 'childrenCount':
          vm.patientProfile.family.childrenCount = numberProvidedRoundedAccepted;
          break;
        case 'lengthOfCondition':
          vm.patientProfile.illnessProfile.lengthOfCondition = numberProvidedRoundedAccepted;
          break;
        case 'gravidity':
          vm.patientProfile.illnessProfile.gravidity = numberProvidedRoundedAccepted;
          break;
        case 'parity':
          vm.patientProfile.illnessProfile.parity = numberProvidedRoundedAccepted;
          break;
        case 'timeToHospital':
          vm.patientProfile.illnessProfile.timeToHospital = numberProvidedRoundedAccepted;
          break;
      }
    },
    decimalNumbersAllowed(event) {
      let charCode = (event.which) ? event.which : event.keyCode;
      if ((charCode >= 48 && charCode <= 57) || charCode === 46 || charCode === 8 || charCode === 127 || charCode === 190) {
        return true;
      } else {
        event.preventDefault();
      }
    },
    resize(textAreaRef) {
      let vm = this;
      let element = vm.$refs[textAreaRef];
      element.style.height = "18px";
      element.style.height = element.scrollHeight + "px";
    },
    selectLocation(locationUid) {
      let vm = this;

      vm.$_.forEach(vm.locationsReturned, function (locationData) {
        if (parseInt(locationData.id) === parseInt(locationUid)) {
          vm.locationPicked = true;
          vm.patientProfile.patientInfo.patientLocation = locationData.location;
          vm.patientProfile.patientInfo.patientDistrict = locationData.district;
          vm.$refs.smallestAdminUnit.scrollIntoView('smooth');
        }
      });
    },
    selectSurgery(surgerySid) {
      let vm = this;

      vm.$_.forEach(vm.surgeriesReturned, function (surgeryData) {
        if (parseInt(surgeryData.id) === parseInt(surgerySid)) {
          vm.surgeryPicked = true;
          vm.patientProfile.illnessProfile.surgeryRequired = surgeryData.surgery;
          vm.patientProfile.illnessProfile.safeAskAmount = `${surgeryData.currency} ${surgeryData.cost}`;
          vm.surgeryHasGravidity = surgeryData.gravidity_ind === 1;
          vm.surgeryHasParity = surgeryData.parity_ind === 1;
        }
      });
    },
    selectRelationship(relationid, relationIndex, relationType) {
      let vm = this;

      vm.$_.forEach(vm.relationshipsReturned[relationType], function (relationData) {
        if (parseInt(relationData.relid) === parseInt(relationid)) {
          vm.relationPicked[relationType] = true;
          switch (relationType) {
            case 'fetchNokRelations':
              vm.patientProfile.patientInfo.nokRelation = relationData.relation;
              break;
            case 'fetchGuardianRelations':
              vm.patientProfile.patientInfo.guardianRelation = relationData.relation;
              break;
          }
        }
      });
    },
    dobSelected(dateSelected) {
      let vm = this;
      let dob = vm.$DateTime.fromJSDate(dateSelected).toUTC(),
          today = vm.$DateTime.local().setZone(vm.currentData.country_tz),
          diffSinceBirth = today.diff(dob, ['years', 'months', 'weeks', 'days']).toObject();
      if (diffSinceBirth.years > 0) {
        vm.memberAgeNumber = diffSinceBirth.years;
        vm.memberAgeUnits = 'Years';
      } else if (diffSinceBirth.months > 0) {
        vm.memberAgeNumber = diffSinceBirth.months;
        vm.memberAgeUnits = 'Months';
      } else if (diffSinceBirth.weeks > 0) {
        vm.memberAgeNumber = diffSinceBirth.weeks;
        vm.memberAgeUnits = 'Weeks';
      } else {
        vm.memberAgeNumber = Math.floor(diffSinceBirth.days);
        vm.memberAgeUnits = 'Days';
      }

      if (parseInt(diffSinceBirth.years) >= 18) {
        vm.patientProfile.socialEconomic.ageGroup = 'patientadult';
        vm.ageGroupName = 'an adult';
        vm.guardianText = 'patient';
        vm.adultBool = true;
        vm.patientProfile.patientInfo.guardianIsNok = false;
      } else {
        vm.patientProfile.socialEconomic.ageGroup = 'patientminor';
        vm.ageGroupName = 'a minor';
        vm.guardianText = 'guardian';
        vm.adultBool = false;
        vm.patientProfile.patientInfo.phoneNumber = '';
        vm.patientProfile.patientInfo.phoneNumberPrefix = '';
        vm.patientProfile.patientInfo.documentType = '';
        vm.patientProfile.patientInfo.documentNumber = '';
      }

    },
    surgeryDateSelected(dateSelected) {
      let vm = this;
      let surgeryDate = vm.$DateTime.fromJSDate(dateSelected).toUTC(),
          today = vm.$DateTime.local().setZone(vm.currentData.country_tz),
          diffToSurgeryDate = surgeryDate.diff(today, ['days', 'hours']).toObject();
      vm.surgeryDateDiffDays = diffToSurgeryDate.days;
    },
    searchLocation() {
      let vm = this;
      if (vm.patientProfile.patientInfo.patientLocation.length >= 3) {
        if (!vm.locationSearchStatus) {
          vm.locationSearchStatus = true;
          try {
            vm.locationsReturned = vm.$_.filter(JSON.parse(localStorage.getItem("location")), function (loc) {
              return loc.location.toLowerCase().indexOf(vm.patientProfile.patientInfo.patientLocation.toLowerCase()) > -1;
            });
            vm.locationSearchStatus = false;
            vm.locationPicked = vm.locationsReturned.length === 0;
            if (vm.locationsReturned.length === 0) {
              vm.districtEnabled = false;
            } else {
              vm.districtEnabled = true;
              vm.patientProfile.patientInfo.patientDistrict = '';
            }
          } catch (error) {
            console.error(error);
            vm.locationSearchStatus = false;
          }
        }
      } else {
        vm.locationsReturned = [];
        vm.locationPicked = true;
      }
    },
    searchSurgery() {
      let vm = this;
      if (vm.patientProfile.illnessProfile.surgeryRequired.length >= 3) {
        if (!vm.surgerySearchStatus) {
          vm.surgerySearchStatus = true;
          try {
            vm.surgeriesReturned = vm.$_.filter(JSON.parse(localStorage.getItem("preapproval")), function (preap) {
              return preap.surgery.toLowerCase().indexOf(vm.patientProfile.illnessProfile.surgeryRequired.toLowerCase()) > -1;
            });
            vm.surgerySearchStatus = false;
            vm.surgeryPicked = vm.surgeriesReturned.length === 0;
          } catch (error) {
            console.error(error);
            vm.surgerySearchStatus = false;
          }
        }
      } else {
        vm.surgeriesReturned = [];
        vm.surgeryPicked = true;
      }
    },
    searchRelationship(dataType) {
      let vm = this;
      switch (dataType) {
        case 'fetchNokRelations':
          if (vm.$_.trim(vm.patientProfile.patientInfo.nokRelation).length >= 1) {
            if (!vm.relationshipSearchStatus.fetchNokRelations) {
              vm.relationshipSearchStatus.fetchNokRelations = true;
              try {
                vm.relationshipsReturned.fetchNokRelations = vm.$_.filter(JSON.parse(localStorage.getItem("relations")), function (rel) {
                  return rel.relation.toLowerCase().indexOf(vm.$_.trim(vm.patientProfile.patientInfo.nokRelation).toLowerCase()) > -1;
                });
                vm.relationshipSearchStatus.fetchNokRelations = false;
                vm.relationPicked.fetchNokRelations = vm.relationshipsReturned.fetchNokRelations.length === 0;
              } catch (error) {
                vm.relationshipSearchStatus.fetchNokRelations = false;
                console.error(error);
              }
            }
          } else {
            vm.relationshipsReturned.fetchNokRelations = [];
            vm.relationPicked.fetchNokRelations = true;
            vm.relationshipSearchStatus.fetchNokRelations = false;
          }
          break;
        case 'fetchGuardianRelations':
          if (vm.$_.trim(vm.patientProfile.patientInfo.guardianRelation).length >= 1) {
            if (!vm.relationshipSearchStatus.fetchGuardianRelations) {
              vm.relationshipSearchStatus.fetchGuardianRelations = true;
              try {
                vm.relationshipsReturned.fetchGuardianRelations = vm.$_.filter(JSON.parse(localStorage.getItem("relations")), function (rel) {
                  return rel.relation.toLowerCase().indexOf(vm.$_.trim(vm.patientProfile.patientInfo.guardianRelation).toLowerCase()) > -1;
                });
                vm.relationshipSearchStatus.fetchGuardianRelations = false;
                vm.relationPicked.fetchGuardianRelations = vm.relationshipsReturned.fetchGuardianRelations.length === 0;
              } catch (error) {
                vm.relationshipSearchStatus.fetchGuardianRelations = false;
                console.error(error);
              }
            }
          } else {
            vm.relationshipsReturned.fetchGuardianRelations = [];
            vm.relationPicked.fetchGuardianRelations = true;
            vm.relationshipSearchStatus.fetchGuardianRelations = false;
          }
          break;
      }
    },
    getProfileCaseId() {
      let vm = this;
      return new Promise(function (resolve, reject) {
        try {
          if (!vm.fetchingCaseId) {
            vm.fetchingCaseId = true;
            vm.$axios
                .post('/profile/action/assignCaseId', {
                  timezone: vm.currentData.country_tz,
                  repData: vm.currentData
                }, {
                  headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${vm.currentData.token}`
                  }
                })
                .then(function (response) {
                  console.log(response.data);
                  resolve(response.data);
                  // if(response.data.success==='true'){
                  //   vm.patientProfile.profileTS = response.data.profileTS;
                  // }
                });
          } else {
            console.log('fetching case id');
          }

        } catch (error) {
          console.error(error);
          reject();
        }
      });
    },
    postDraftProfile() {
      let vm = this;
      try {
        vm.manageDirtyList('dirty', `draftProfile_${vm.patientProfile.profileTS}`);
        vm.$axios
            .post('/profile/action/updateDraftProfile', {
              draftProfile: vm.patientProfile,
              repData: vm.currentData,
              updateNumber: vm.updateNumber++,
              returnedProfile: vm.returnedProfile
            }, {
              headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${vm.currentData.token}`
              }
            })
            .then(function (response) {
              switch (response.data.success) {
                case 'true':
                  if ((response.data.updateNumber + 1) === vm.updateNumber) {
                    vm.patientProfile = response.data.patientProfile;
                    vm.summaryProfile = response.data.summaryJson;
                    vm.draftResp = true;
                  }
                  break;
              }
            })
      } catch (error) {
        console.error(error);
      }
    },
    onComplete() {
      let vm = this;
      if (vm.v$.$errors.length === 0 && !vm.navigationBlockedByCaseId) {
        let wizardButtons = document.querySelectorAll(".wizard-btn");
        vm.$_.forEach(wizardButtons, function (wizardButton) {
          wizardButton.disabled = true;
        });
        try {
          vm.manageDirtyList('dirty', `submitDraftProfile_${vm.patientProfile.profileTS}`);
          vm.$axios
              .post('/profile/action/submitDraftProfile', {
                draftProfile: vm.patientProfile,
                repData: vm.currentData,
                returnedProfile: vm.returnedProfile
              }, {
                headers: {
                  'Content-Type': 'application/json',
                  Authorization: `Bearer ${vm.currentData.token}`
                }
              })
              .then(function (response) {
                switch (response.data.success) {
                  case 'true':
                    vm.profileSubmittedMsg = response.data.msg;
                    vm.ResetProfileForm();
                    vm.profileSubmitted = true;
                    break;
                  case 'false':
                    vm.$_.forEach(wizardButtons, function (wizardButton) {
                      wizardButton.disabled = false;
                    });
                    vm.profileSubmitted = false;
                    break;
                }
              });
        } catch (error) {
          console.error(error);
          vm.$_.forEach(wizardButtons, function (wizardButton) {
            wizardButton.disabled = false;
          });
        }
      }
    },


    async validateForm() {
      const vm = this;
      await this.v$.$validate();
      vm.validationHasOccured = true;
    },
    onTabChange(prevIndex, nextIndex) {
      let vm = this;
      vm.leavingTab = prevIndex;
      vm.enteringTab = nextIndex;

      if (prevIndex === 0) {
        vm.showErrors[0] = true;
      }

      if (prevIndex === 1) {
        vm.showErrors[1] = true;
      }

      if (prevIndex === 2) {
        vm.showErrors[2] = true;
      }

      if (nextIndex !== 3) {
        vm.validateForm();
      }

      document.getElementsByClassName("wizard-nav wizard-nav-pills")[0].scrollIntoView('smooth');


    },
    dropZone2Emissions(dropZone2Emission) {
      let vm = this;
      vm.patientProfile.dropzone2Trigger = `${dropZone2Emission.action}@${vm.$DateTime.local().setZone(vm.currentData.country_tz).toUnixInteger()}`;
      if (dropZone2Emission.action === 'imageRemoved') {
        vm.patientProfile.confirmation[dropZone2Emission.fileIdentifier] = '';
      }
    },
    displayErrorsForTab(tabName) {
      let vm = this,
          returnedErrors = [],
          errorParts = [],
          tabsErrorShow = {"Personal Tab": 0, "Illness Tab": 1, "Attachments Tab": 2};
      vm.$_.forEach(vm.v$.$errors, function (error) {
        if (error.$message.toString().indexOf(tabName) === 1 && vm.showErrors[tabsErrorShow[tabName]]) {
          errorParts = vm.$_.split(error.$message, '}');
          returnedErrors.push({uid: error.$uid, message: errorParts[1]});
        }
      });
      return returnedErrors;
    },
    setPatientPhoneNumberData(emittedObj) {
      let vm = this;
      vm.patientProfile.patientInfo.phoneNumberPrefix = emittedObj.countryPrefixDigits;
      vm.patientProfile.patientInfo.phoneNumber = emittedObj.phoneNumberDigits;
    },
    setGuardianPhoneNumberData(emittedObj) {
      let vm = this;
      vm.patientProfile.patientInfo.guardianPhonePrefix = emittedObj.countryPrefixDigits;
      vm.patientProfile.patientInfo.guardianPhone = emittedObj.phoneNumberDigits;
    },
    setNokPhoneNumberData(emittedObj) {
      let vm = this;
      vm.patientProfile.patientInfo.nokPhonePrefix = emittedObj.countryPrefixDigits;
      vm.patientProfile.patientInfo.nokPhone = emittedObj.phoneNumberDigits;
    },
    coPaymentDataValReceived(emittedObj) {
      let vm = this;
      vm.patientProfile.illnessProfile.coPaymentOOPCurrency = emittedObj.coPaymentOOPCurrency;
      vm.patientProfile.illnessProfile.coPaymentOOPAmount = emittedObj.coPaymentOOPAmount;
      vm.patientProfile.illnessProfile.coPaymentInsCurrency = emittedObj.coPaymentInsCurrency;
      vm.patientProfile.illnessProfile.coPaymentInsAmount = emittedObj.coPaymentInsAmount;
      vm.patientProfile.illnessProfile.insuranceProvider = emittedObj.insuranceProvider;

    },
    displayDateOnly(dateOfBirthInUtc) {
      let vm = this;
      return vm.$DateTime.fromISO(dateOfBirthInUtc).toFormat('dd-LLL-yyyy');
    },
    goToErrorTab(tabErrorText) {
      if (tabErrorText.indexOf('{Personal Tab}') === 0) {
        document.getElementById('step-Personal0').click()
      }
      if (tabErrorText.indexOf('{Illness Tab}') === 0) {
        document.getElementById('step-Illness1').click()
      }
      if (tabErrorText.indexOf('{Attachments Tab}') === 0) {
        document.getElementById('step-Attachments2').click()
      }
    },
    previewURL(imageSource, initialViewIndex) {

      let vm = this;

      viewerApi({
        options: {
          "inline": false,
          "button": true,
          "navbar": true,
          "title": true,
          "toolbar": true,
          "tooltip": true,
          "movable": true,
          "zoomable": true,
          "rotatable": true,
          "scalable": true,
          "transition": true,
          "fullscreen": true,
          "keyboard": true,
          "url": "data-source",
          initialViewIndex: initialViewIndex
        },
        images: vm.sourceImageURLs[imageSource]
      })
    }
  },
  computed: {
    coordinatorNotNotified() {
      let vm = this;
      return vm.patientProfile.illnessProfile.coordinatorNotified === 'coordinatornotifiedno';
    },
    surgeriesAvailable() {
      let vm = this,
          surgeriesReturned = [];
      try {
        vm.surgeriesReturned = surgeriesReturned = JSON.parse(localStorage.getItem("preapproval"))
      } catch (error) {
        console.error(error);
        vm.surgeriesReturned = surgeriesReturned = [];
      }
      return surgeriesReturned;
    },
    expectingID() {
      let vm = this;
      return (vm.patientProfile.patientInfo.documentType === 'identificationCard' || vm.patientProfile.patientInfo.guardianDocumentType === 'identificationCard')
    },
    expectingPassport() {
      let vm = this;
      return (vm.patientProfile.patientInfo.documentType === 'travellersPassport' || vm.patientProfile.patientInfo.guardianDocumentType === 'travellersPassport')
    },
    expectingDl() {
      let vm = this;
      return (vm.patientProfile.patientInfo.documentType === 'drivingLicence' || vm.patientProfile.patientInfo.guardianDocumentType === 'drivingLicence')
    },
    dobDateConstrain() {
      let vm = this;
      if (typeof vm.currentData.country_tz !== 'undefined') {
        return {
          from: vm.$DateTime.local().setZone(vm.currentData.country_tz).toJSDate()
        }
      } else {
        return {};
      }

    },
    surgeryDateConstrain() {
      let vm = this,
          returnConfig;
      switch (vm.patientProfile.illnessProfile.surgeryType) {
        case 'surgerytypeelective':
          if (typeof vm.currentData.country_tz !== 'undefined') {
            returnConfig = {
              to: vm.$DateTime.local().setZone(vm.currentData.country_tz).minus({days: 1}).toJSDate()
            };
          } else {
            returnConfig = {};
          }
          break;
        case 'surgerytypeemergency':
          returnConfig = {};
          break;
        default:
          returnConfig = {
            to: vm.$DateTime.local().setZone(vm.currentData.country_tz).toJSDate()
          };
          break;
      }
      return returnConfig;
    },
    householdDependentsPlaceholder() {
      let vm = this;
      return `Please specify the number of household members the ${vm.guardianText} supports`;
    },
    isMinorWithDifferentNok() {
      let vm = this;
      if (vm.adultBool) {
        return vm.adultBool
      } else {
        return !vm.patientProfile.patientInfo.guardianIsNok;
      }
    },
    hasSomeFormOfEmployment() {
      let vm = this;
      return vm.patientProfile.socialEconomic.profile === 'patientemployed' || vm.patientProfile.socialEconomic.profile === 'patientselfemployed';
    },
    setDatePickerClassDob() {
      let vm = this;
      try {
        if (vm.v$.patientProfile.patientInfo.dob.$errors.length > 0 && vm.showErrors[0]) {
          return 'wrapper-custom input error-input';
        } else {
          return 'wrapper-custom input';
        }
      } catch (error) {
        return 'wrapper-custom input';
      }
    },
    setDatePickerClassSurgeryDate() {
      let vm = this;
      try {
        if (vm.v$.patientProfile.illnessProfile.estDateOfSurgery.$errors.length > 0 && vm.showErrors[1]) {
          return 'wrapper-custom input error-input';
        } else {
          return 'wrapper-custom input';
        }
      } catch (error) {
        return 'wrapper-custom input';
      }
    },
    disableEmploymentForm() {
      let vm = this;
      return vm.patientProfile.socialEconomic.profile !== 'patientemployed';
    },
    disableMonthlyIncome() {
      let vm = this;
      return vm.patientProfile.socialEconomic.profile === 'patientunemployed';
    },
    summaryAvailableBool() {
      let vm = this;
      return vm.validationHasOccured && vm.v$.$errors.length <= 0;
    },
    returnPatientPhoneContact() {
      let vm = this;
      return {
        phoneNumber: vm.patientProfile.patientInfo.phoneNumber,
        phoneNumberPrefix: vm.patientProfile.patientInfo.phoneNumberPrefix
      };
    },
    returnGuardianPhoneContact() {
      let vm = this;
      return {
        phoneNumber: vm.patientProfile.patientInfo.guardianPhone,
        phoneNumberPrefix: vm.patientProfile.patientInfo.guardianPhonePrefix
      };
    },
    returnNokPhoneContact() {
      let vm = this;
      return {
        phoneNumber: vm.patientProfile.patientInfo.nokPhone,
        phoneNumberPrefix: vm.patientProfile.patientInfo.nokPhonePrefix
      };
    },
    returnCopaymentDataObj() {
      let vm = this;
      return {
        coPaymentOOPCurrency: vm.patientProfile.illnessProfile.coPaymentOOPCurrency,
        coPaymentOOPAmount: vm.patientProfile.illnessProfile.coPaymentOOPAmount,
        coPaymentInsCurrency: vm.patientProfile.illnessProfile.coPaymentInsCurrency,
        coPaymentInsAmount: vm.patientProfile.illnessProfile.coPaymentInsAmount,
        insuranceProvider: vm.patientProfile.illnessProfile.insuranceProvider,
      }
    },
    copaymentRequired() {
      let vm = this,
          copaymentRequiredBool = false;
      if (vm.patientProfile.illnessProfile.isCoPaying) {
        copaymentRequiredBool = parseInt(vm.patientProfile.illnessProfile.coPaymentOOPAmount) === 0 && parseInt(vm.patientProfile.illnessProfile.coPaymentInsAmount) === 0;
      }

      return copaymentRequiredBool;
    },
    inputsDisabled() {
      let vm = this;
      return vm.returnedProfile && vm.currentData.role !== 'Representative';
    },
    sourceImageURLs() {
      let vm = this;
      let imageURLs = {preop: [], condition: [], ids: [], attachments: []};
      vm.$_.forEach(vm.summaryProfile.faceImages, function (faceImage) {
        imageURLs.preop.push({
          'src': faceImage.view,
          'data-source': faceImage.view,
        });
      });
      vm.$_.forEach(vm.summaryProfile.conditionImages, function (conditionImage) {
        imageURLs.condition.push({
          'src': conditionImage.view,
          'data-source': conditionImage.view,
        });
      });
      vm.$_.forEach(vm.summaryProfile.identificationImages, function (identificationImage) {
        imageURLs.ids.push({
          'src': identificationImage.view,
          'data-source': identificationImage.view,
        });
      });
      imageURLs.attachments.push({
        'src': vm.summaryProfile.waiverImages[0].view,
        'data-source': vm.summaryProfile.waiverImages[0].view,
      });
      vm.$_.forEach(vm.summaryProfile.additionalAttachments, function (additionalAttachment) {
        imageURLs.attachments.push({
          'src': additionalAttachment.view,
          'data-source': additionalAttachment.view,
        });
      });
      return imageURLs;
    },
    showCaseId() {
      let vm = this;
      if (vm.$_.trim(vm.patientProfile.profileTS) !== '') {
        return `<p style="color: green;">Case ID: ${vm.$_.trim(vm.patientProfile.profileTS)}</p>`;
      } else {
        return '<p style="color: red;">Please fill in the patient name to generate a case ID</p>';
      }
    },
    blockNextButton() {
      let vm = this;
      if (vm.$_.trim(vm.patientProfile.profileTS) !== '') {
        if (vm.navigationBlockedByCaseId) {
          let wizardButtons = document.querySelectorAll(".wizard-btn");
          vm.$_.forEach(wizardButtons, function (wizardButton) {
            wizardButton.disabled = false;
          });
          vm.navigationBlockedByCaseId = false;
        }
        return '';
      } else {
        let wizardButtons = document.querySelectorAll(".wizard-btn");
        vm.$_.forEach(wizardButtons, function (wizardButton) {
          wizardButton.disabled = true;
        });
        vm.navigationBlockedByCaseId = true;
        return '<p style="color: red;">You cannot proceed without a case ID. Please fill in the patient name to generate a case ID</p>';
      }
    }
  },
  watch: {
    patientProfile: {
      async handler(newValue) {
        let vm = this;
        if (newValue.socialEconomic.profile === 'patientunemployed') {
          vm.patientProfile.socialEconomic.profileDetails = '';
          vm.patientProfile.socialEconomic.employmentForm = '';
          vm.patientProfile.socialEconomic.employmentFormDetails = '';
          vm.patientProfile.socialEconomic.monthlyIncome = '';
        }

        if (newValue.socialEconomic.profile === 'patientselfemployed') {
          vm.patientProfile.socialEconomic.employmentForm = '';
          vm.patientProfile.socialEconomic.employmentFormDetails = '';
        }

        if (newValue.socialEconomic.profile === 'patientemployed') {
          vm.patientProfile.socialEconomic.profileDetails = '';
        }

        vm.nokBool = !newValue.patientInfo.guardianIsNok;

        if (newValue.patientInfo.patientPrivacy === 'privacyyes') {
          vm.disablePrivacyReason = false;
        }

        if (newValue.patientInfo.documentType === 'noneAvaiable') {
          vm.patientProfile.patientInfo.documentNumber = '-';
        }
        if (newValue.patientInfo.guardianDocumentType === 'noneAvaiable') {
          vm.patientProfile.patientInfo.guardianDocumentNumber = '-';
        }

        if (newValue.patientInfo.patientPrivacy === 'privacyno') {
          vm.disablePrivacyReason = true;
          vm.patientProfile.patientInfo.patientPrivacyReason = '';
        }

        if (newValue.illnessProfile.coordinatorNotified === 'coordinatornotifiedno') {
          vm.patientProfile.illnessProfile.coordinatorNotifiedMeans = '';
        }

        if (newValue.illnessProfile.surgeryType === 'surgerytypeelective') {
          vm.patientProfile.illnessProfile.coordinatorNotified = '';
          vm.patientProfile.illnessProfile.coordinatorNotifiedMeans = '';
        }

        if (newValue.illnessProfile.transportation !== 'modeoftransporttohospitalother') {
          vm.patientProfile.illnessProfile.transportationOther = '';
        }

        if (newValue.illnessProfile.surgeryRequired !== '') {
          vm.$_.forEach(vm.surgeriesReturned, function (surgeryData) {
            if (vm.$_.trim(surgeryData.surgery).toLowerCase() === vm.$_.trim(newValue.illnessProfile.surgeryRequired).toLowerCase()) {
              vm.surgeryPicked = true;
              vm.patientProfile.illnessProfile.safeAskAmount = `${surgeryData.currency} ${surgeryData.cost}`;
              vm.patientProfile.illnessProfile.surgeryId = surgeryData.id;
              // vm.surgeryWillAutoApprove = surgeryData.auto_approve_profile === 1;
              vm.patientProfile.illnessProfile.autoApprove = surgeryData.auto_approve_profile === 1;
              vm.patientProfile.illnessProfile.autoApprovePocket = (surgeryData.auto_approve_profile === 1) ? surgeryData.autoapproval_pocket : '';
              vm.surgeryHasGravidity = surgeryData.gravidity_ind === 1;
              vm.surgeryHasParity = surgeryData.parity_ind === 1;
            }
          });
        }

        if (vm.patientProfile.patientInfo.dob) {
          if (typeof vm.patientProfile.patientInfo.dob === 'string') {
            vm.dobSelected(vm.$DateTime.fromISO(vm.patientProfile.patientInfo.dob).toJSDate());
          } else {
            vm.dobSelected(vm.patientProfile.patientInfo.dob);
          }
        }


        let draftProfileString = localStorage.getItem("draftprofile");
        let getProfileCaseIdResp;

        // if (vm.currentData.partnerid !== 17) {
        //   if (draftProfileString) {
        //     // console.log('draftProfileString', draftProfileString);
        //     if (vm.$_.trim(vm.patientProfile.profileTS) === '') {
        //       vm.patientProfile.profileTS = vm.$DateTime.local().setZone(vm.currentData.country_tz).toUnixInteger();
        //     }
        //     localStorage.setItem("draftprofile", JSON.stringify({
        //       patientProfile: vm.patientProfile,
        //       returnedProfile: vm.returnedProfile
        //     }));
        //   } else {
        //     // console.log('draftProfileString is empty');
        //     vm.patientProfile.profileTS = vm.$DateTime.local().setZone(vm.currentData.country_tz).toUnixInteger();
        //     localStorage.setItem("draftprofile", JSON.stringify({
        //       patientProfile: vm.patientProfile,
        //       returnedProfile: vm.returnedProfile
        //     }));
        //     vm.patientProfileFromDraft = true;
        //   }
        // } else {
        if (draftProfileString) {
          // console.log('draftProfileString', draftProfileString);
          if (vm.$_.trim(vm.patientProfile.profileTS) === '') {
            // vm.ResetProfileForm()
            if (vm.$_.trim(vm.patientProfile.patientInfo.name) !== '') {
              getProfileCaseIdResp = await vm.getProfileCaseId();
              // console.log(getProfileCaseIdResp);
              if (getProfileCaseIdResp.success === 'true') {
                vm.patientProfile.profileTS = parseInt(getProfileCaseIdResp.caseId);
              }
              vm.fetchingCaseId = false;
            }
          }
          localStorage.setItem("draftprofile", JSON.stringify({
            patientProfile: vm.patientProfile,
            returnedProfile: vm.returnedProfile
          }));
        } else {
          // console.log('draftProfileString is empty');
          if (vm.$_.trim(vm.patientProfile.patientInfo.name) !== '') {
            getProfileCaseIdResp = await vm.getProfileCaseId();
            // console.log(getProfileCaseIdResp);
            if (getProfileCaseIdResp.success === 'true') {
              vm.patientProfile.profileTS = parseInt(getProfileCaseIdResp.caseId);
            }
            vm.fetchingCaseId = false;
          }
          localStorage.setItem("draftprofile", JSON.stringify({
            patientProfile: vm.patientProfile,
            returnedProfile: vm.returnedProfile
          }));
          vm.patientProfileFromDraft = true;
        }
        // }

        if (vm.draftResp) {
          vm.draftResp = false;
        } else {
          if (vm.$_.trim(vm.patientProfile.profileTS) !== '' && vm.$_.trim(vm.patientProfile.patientInfo.name) !== '') {
            vm.postDraftProfile()
          }
        }
      },
      deep: true
    }
  },
  async mounted() {
    let vm = this;
    const storedAccount = localStorage.getItem("account");
    vm.currentData = JSON.parse(storedAccount);
    vm.currentDataLoaded = true;

    vm.IDB = await vm.getIDB()

    if (vm.$_.trim(vm.draftProfileTs) === '') {
      const draftProfileString = localStorage.getItem("draftprofile");
      if (draftProfileString) {
        let draftProfileStringObj = JSON.parse(draftProfileString);
        vm.patientProfile = draftProfileStringObj.patientProfile;
        vm.returnedProfile = draftProfileStringObj.returnedProfile;
        vm.patientProfileFromDraft = true;
      }
    } else {
      if (vm.returnedProfile) {
        let returnedProfilePatient = await vm.getPatientFromDb(vm.IDB, 'returnedProfiles', vm.$_.trim(vm.draftProfileTs), 'caseId', false);

        if (typeof returnedProfilePatient[0] !== 'undefined') {
          vm.patientProfile = returnedProfilePatient[0].caseData.patientProfile;
          vm.patientProfileFromDraft = true;
          localStorage.setItem("draftprofile", JSON.stringify({
            patientProfile: vm.patientProfile,
            returnedProfile: vm.returnedProfile
          }))
        }


      } else {
        let draftProfilePatient = await vm.getPatientFromDb(vm.IDB, 'draftProfiles', vm.$_.trim(vm.draftProfileTs), 'caseId', false);
        if (typeof draftProfilePatient[0] !== 'undefined') {
          vm.patientProfileIdentifier = draftProfilePatient[0].caseData.profileIdentifier;
          vm.patientProfile = draftProfilePatient[0].caseData.patientProfile;
          vm.patientProfileFromDraft = true;
          localStorage.setItem("draftprofile", JSON.stringify({
            patientProfile: vm.patientProfile,
            returnedProfile: vm.returnedProfile
          }))
        }

      }

    }

  }
};
</script>

<template>
  <div class="profile-form-container" v-if="!profileSubmitted && currentDataLoaded">
    <div class="container">
      <div class="columns is-multiline is-vcentered">
        <div class="column is-half">
          <span v-html="showCaseId"></span>
        </div>
        <div class="column is-one-quarter">
        </div>
        <div class="column is-one-quarter">
          <button class="button is-fullwidth" v-on:click="ResetProfileForm">Save and Create New Draft</button>
        </div>
      </div>
    </div>
    <FormWizard @on-complete="onComplete" @on-change="onTabChange" color="#094899" class="" step-size="md">
      <TabContent title="Personal" ref="personalTab" icon="fa fa-user">
        <div class="container">
          <div class="columns is-multiline is-vcentered">

            <div class="column is-full">
              <h1 class="is-size-3 is-underlined">Patient Information</h1>
            </div>

            <div class="column is-full">
              <div id="personalOne" class="columns is-multiline is-vcentered section-box">
                <div class="column is-full section-box-title-column">
                  <div class="section-box-title-text">Personal</div>
                </div>

                <div class="column is-5 has-text-left bottom-border-input right-border-input">
                  <label class="label has-text-centered">Full Name</label>
                  <div class="field">
                    <p class="control is-expanded has-icons-left">
                      <input class="input input-no-top-margin" type="text" placeholder="Name"
                             v-model="patientProfile.patientInfo.name"
                             v-bind:class="{'error-input':v$.patientProfile.patientInfo.name.$errors.length>0 && showErrors[0]}"
                             v-bind:disabled="inputsDisabled"
                      >
                      <span class="icon is-small is-left">
                  <font-awesome-icon :icon="['fas', 'user']"/>
                </span>
                    </p>
                  </div>
                </div>
                <div class="column is-3 has-text-left bottom-border-input right-border-input">
                  <label class="label has-text-centered">Patient Hospital Number</label>
                  <div class="field">
                    <p class="control is-expanded has-icons-left">
                      <input class="input input-no-top-margin" type="text" placeholder="Inpatient Number"
                             v-model="patientProfile.patientInfo.inpatientNumber" v-bind:disabled="inputsDisabled">
                      <span class="icon is-small is-left">
                  <font-awesome-icon :icon="['fas', 'address-card']"/>
                </span>
                    </p>
                  </div>
                </div>
                <div class="column is-4 has-text-left bottom-border-input">
                  <label class="label has-text-centered">Patient Type</label>
                  <div class="field is-narrow">
                    <div class="control">
                      <div class="fancy-input-group padded-checkboxes columns is-multiline is-vcentered"
                           v-bind:class="{'error-input':v$.patientProfile.patientInfo.patientType.$errors.length>0 && showErrors[0]}">
                        <input v-bind:disabled="inputsDisabled" type="radio" name="patienttype" id="patientnew"
                               value="patientnew"
                               class="fancy-input"
                               v-model="patientProfile.patientInfo.patientType"/>
                        <label for="patientnew" class="fancy-input-label column no-wrapping-label">New</label>
                        <input v-bind:disabled="inputsDisabled" type="radio" name="patienttype" id="patientresubmission"
                               value="patientresubmission"
                               class="fancy-input" v-model="patientProfile.patientInfo.patientType"/>
                        <label for="patientresubmission"
                               class="fancy-input-label column no-wrapping-label">Resubmission</label>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="column is-half has-text-left bottom-border-input right-border-input">
                  <label class="label has-text-centered">Gender</label>
                  <div class="field is-narrow">
                    <div class="control">
                      <div class="fancy-input-group padded-checkboxes columns is-multiline is-vcentered"
                           v-bind:class="{'error-input':v$.patientProfile.patientInfo.gender.$errors.length>0 && showErrors[0]}">
                        <input v-bind:disabled="inputsDisabled" type="radio" name="patientgender" id="patientmale"
                               value="patientmale"
                               class="fancy-input"
                               v-model="patientProfile.patientInfo.gender"/>
                        <label for="patientmale" class="fancy-input-label column no-wrapping-label">Male</label>
                        <input v-bind:disabled="inputsDisabled" type="radio" name="patientgender" id="patientfemale"
                               value="patientfemale"
                               class="fancy-input" v-model="patientProfile.patientInfo.gender"/>
                        <label for="patientfemale" class="fancy-input-label column no-wrapping-label">Female</label>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="column is-half has-text-left bottom-border-input">
                  <label class="label has-text-centered">Date of Birth (Age: {{ memberAgeNumber }} {{
                      memberAgeUnits
                    }})</label>
                  <div class="field" v-if="inputsDisabled">
                    <p class="control is-expanded has-icons-left">
                      <input class="input input-no-top-margin" type="text" placeholder=""
                             v-bind:value="displayDateOnly(patientProfile.patientInfo.dob)"
                             v-bind:disabled="inputsDisabled">
                      <span class="icon is-small is-left">
                  <font-awesome-icon :icon="['fas', 'calendar-days']"/>
                </span>
                    </p>
                  </div>
                  <div class="field" v-else>
                    <p class="control is-expanded">
                      <datepicker v-model="patientProfile.patientInfo.dob" name="patientdob"
                                  v-bind:disabled-dates="dobDateConstrain"
                                  v-bind:clear-button="true"
                                  v-bind:input-class="'input-custom'"
                                  v-bind:wrapper-class="setDatePickerClassDob"
                                  v-bind:calendar-class="'calendar-custom'"
                                  v-on:selected="dobSelected"></datepicker>
                    </p>
                  </div>
                </div>

                <div class="column is-full has-text-left bottom-border-input">
                  <label class="label has-text-centered">Marital Status</label>
                  <div class="field is-narrow">
                    <div class="control">
                      <div class="fancy-input-group padded-checkboxes columns is-multiline is-vcentered"
                           v-bind:class="{'error-input':v$.patientProfile.patientInfo.marital.$errors.length>0 && showErrors[0]}">
                        <input v-bind:disabled="inputsDisabled" type="radio" name="patientmarital" id="patientsingle"
                               value="patientsingle"
                               class="fancy-input" v-model="patientProfile.patientInfo.marital"/>
                        <label for="patientsingle" class="fancy-input-label column no-wrapping-label">Single</label>
                        <input v-bind:disabled="inputsDisabled" type="radio" name="patientmarital" id="patientmarried"
                               value="patientmarried"
                               class="fancy-input" v-model="patientProfile.patientInfo.marital"/>
                        <label for="patientmarried" class="fancy-input-label column no-wrapping-label">Married</label>
                        <input v-bind:disabled="inputsDisabled" type="radio" name="patientmarital" id="patientseparated"
                               value="patientseparated"
                               class="fancy-input" v-model="patientProfile.patientInfo.marital"/>
                        <label for="patientseparated"
                               class="fancy-input-label column no-wrapping-label">Separated</label>
                        <input v-bind:disabled="inputsDisabled" type="radio" name="patientmarital" id="patientswidowed"
                               value="patientswidowed"
                               class="fancy-input" v-model="patientProfile.patientInfo.marital"/>
                        <label for="patientswidowed" class="fancy-input-label column no-wrapping-label">Widowed</label>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="column is-full has-text-left bottom-border-input">
                  <label class="label has-text-centered">Education Level</label>
                  <div class="field is-narrow">
                    <div class="control">
                      <div class="fancy-input-group padded-checkboxes columns is-multiline is-vcentered"
                           v-bind:class="{'error-input':v$.patientProfile.patientInfo.education.$errors.length>0 && showErrors[0]}">
                        <input v-bind:disabled="inputsDisabled" type="radio" name="educationlevel" id="educationnone"
                               value="educationnone"
                               class="fancy-input" v-model="patientProfile.patientInfo.education"/>
                        <label for="educationnone" class="fancy-input-label column no-wrapping-label">None</label>
                        <input v-bind:disabled="inputsDisabled" type="radio" name="educationlevel" id="educationprimary"
                               value="educationprimary"
                               class="fancy-input" v-model="patientProfile.patientInfo.education"/>
                        <label for="educationprimary" class="fancy-input-label column no-wrapping-label">Primary</label>
                        <input v-bind:disabled="inputsDisabled" type="radio" name="educationlevel"
                               id="educationsecondary" value="educationsecondary"
                               class="fancy-input" v-model="patientProfile.patientInfo.education"/>
                        <label for="educationsecondary"
                               class="fancy-input-label column no-wrapping-label">Secondary</label>
                        <input v-bind:disabled="inputsDisabled" type="radio" name="educationlevel"
                               id="educationtertiary" value="educationtertiary"
                               class="fancy-input" v-model="patientProfile.patientInfo.education"/>
                        <label for="educationtertiary"
                               class="fancy-input-label column no-wrapping-label">Tertiary</label>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="column is-half has-text-left bottom-border-input right-border-input">
                  <label class="label has-text-centered">Patient Descriptor</label>
                  <div class="field">
                    <p class="control is-expanded has-icons-left">
                      <input v-bind:disabled="inputsDisabled" class="input input-no-top-margin" type="text"
                             placeholder="student, farmer, baby"
                             v-model="patientProfile.patientInfo.patientDescriptor"
                             v-bind:class="{'error-input':v$.patientProfile.patientInfo.patientDescriptor.$errors.length>0 && showErrors[0]}">
                      <span class="icon is-small is-left">
                  <font-awesome-icon :icon="['fas', 'user-tie']"/>
                </span>
                    </p>
                  </div>
                </div>
                <div class="column is-half has-text-left bottom-border-input">
                  <label class="label has-text-centered">Has Health Insurance</label>
                  <div class="field is-narrow">
                    <div class="control">
                      <div class="fancy-input-group padded-checkboxes columns is-multiline is-vcentered"
                           v-bind:class="{'error-input':v$.patientProfile.patientInfo.healthInsurance.$errors.length>0 && showErrors[0]}">
                        <input v-bind:disabled="inputsDisabled" type="radio" name="healthinsurance" id="insuranceyes"
                               value="insuranceyes"
                               class="fancy-input" v-model="patientProfile.patientInfo.healthInsurance"/>
                        <label for="insuranceyes" class="fancy-input-label column no-wrapping-label">Yes</label>
                        <input v-bind:disabled="inputsDisabled" type="radio" name="healthinsurance" id="insuranceno"
                               value="insuranceno"
                               class="fancy-input"
                               v-model="patientProfile.patientInfo.healthInsurance"/>
                        <label for="insuranceno" class="fancy-input-label column no-wrapping-label">No</label>
                      </div>
                    </div>
                  </div>
                </div>


                <div class="column is-half has-text-left bottom-border-input-mobile right-border-input"
                     v-if="adultBool">
                  <label class="label has-text-centered">Phone Number of the Patient</label>
                  <mobileNumberInput
                      v-bind:phoneContact="returnPatientPhoneContact"
                      v-bind:countryPrefixError="v$.patientProfile.patientInfo.phoneNumberPrefix.$errors.length>0 && showErrors[0]"
                      v-bind:phoneNumberError="v$.patientProfile.patientInfo.phoneNumber.$errors.length>0 && showErrors[0]"
                      v-bind:countryName="currentData.country"
                      v-bind:textDataName="'Phone Number'"
                      v-bind:inputsDisabled="inputsDisabled"
                      v-on:phoneNumberProvided="setPatientPhoneNumberData"
                  ></mobileNumberInput>
                </div>
                <div class="column is-half has-text-left" v-if="adultBool">
                  <label class="label has-text-centered">Government Identification</label>
                  <div class="field has-addons">
                    <p class="control">
                <span class="select">
                  <select v-bind:disabled="inputsDisabled" v-model="patientProfile.patientInfo.documentType"
                          v-bind:class="{'error-input':v$.patientProfile.patientInfo.documentType.$errors.length>0 && showErrors[0]}">
                    <option disabled value="">Select One</option>
                    <option value="identificationCard">ID</option>
                    <option value="drivingLicence">DL</option>
                    <option value="travellersPassport">PP</option>
                    <option value="noneAvaiable">N/A</option>
                  </select>
                </span>
                    </p>
                    <p class="control is-expanded">
                      <input v-bind:disabled="inputsDisabled" class="input input-no-margin-top" type="text"
                             placeholder="Number"
                             v-bind:class="{'error-input':v$.patientProfile.patientInfo.documentNumber.$errors.length>0 && showErrors[0]}"
                             v-model="patientProfile.patientInfo.documentNumber">
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div class="column is-full" v-if="!adultBool"></div>
            <div class="column is-full" v-if="!adultBool">
              <div id="personalTwo" class="columns is-multiline is-vcentered section-box">
                <div class="column is-full section-box-title-column">
                  <div class="section-box-title-text">Guardian</div>
                </div>

                <div class="column is-half has-text-left bottom-border-input right-border-input">
                  <label class="label has-text-centered">Guardian Name</label>
                  <div class="field">
                    <p class="control is-expanded has-icons-left">
                      <input v-bind:disabled="inputsDisabled" class="input input-no-top-margin" type="text"
                             placeholder="Name"
                             v-bind:class="{'error-input':v$.patientProfile.patientInfo.guardianName.$errors.length>0 && showErrors[0]}"
                             v-model="patientProfile.patientInfo.guardianName">
                      <span class="icon is-small is-left">
                  <font-awesome-icon :icon="['fas', 'person-shelter']"/>
                </span>
                    </p>
                  </div>
                </div>
                <div class="column is-half has-text-left bottom-border-input">
                  <label class="label has-text-centered">Government Identification</label>
                  <div class="field has-addons">
                    <p class="control">
                <span class="select">
                  <select v-bind:disabled="inputsDisabled" v-model="patientProfile.patientInfo.guardianDocumentType"
                          v-bind:class="{'error-input':v$.patientProfile.patientInfo.guardianDocumentType.$errors.length>0 && showErrors[0]}">
                    <option disabled value="">Select One</option>
                    <option value="identificationCard">ID</option>
                    <option value="drivingLicence">DL</option>
                    <option value="travellersPassport">PP</option>
                    <option value="noneAvaiable">N/A</option>
                  </select>
                </span>
                    </p>
                    <p class="control is-expanded">
                      <input v-bind:disabled="inputsDisabled" class="input input-no-margin-top" type="text"
                             placeholder="Number"
                             v-bind:class="{'error-input':v$.patientProfile.patientInfo.guardianDocumentNumber.$errors.length>0 && showErrors[0]}"
                             v-model="patientProfile.patientInfo.guardianDocumentNumber">
                    </p>
                  </div>
                </div>

                <div class="column is-half has-text-left bottom-border-input-mobile right-border-input">
                  <label class="label has-text-centered">Guardian Phone Number</label>
                  <mobileNumberInput
                      v-bind:phoneContact="returnGuardianPhoneContact"
                      v-bind:countryPrefixError="v$.patientProfile.patientInfo.guardianPhonePrefix.$errors.length>0 && showErrors[0]"
                      v-bind:phoneNumberError="v$.patientProfile.patientInfo.guardianPhone.$errors.length>0 && showErrors[0]"
                      v-bind:countryName="currentData.country"
                      v-bind:textDataName="'Phone Number'"
                      v-bind:inputsDisabled="inputsDisabled"
                      v-on:phoneNumberProvided="setGuardianPhoneNumberData"
                  ></mobileNumberInput>
                </div>
                <div class="column is-one-quarter has-text-left bottom-border-input-mobile right-border-input">
                  <label class="label has-text-centered">Relationship</label>
                  <div class="field">
                    <p class="control is-expanded has-icons-left">
                      <input v-bind:disabled="inputsDisabled" class="input input-no-top-margin" type="text"
                             placeholder="Relationship"
                             v-bind:class="{'error-input':v$.patientProfile.patientInfo.guardianRelation.$errors.length>0 && showErrors[0]}"
                             v-on:keyup="searchRelationship('fetchGuardianRelations')"
                             v-model="patientProfile.patientInfo.guardianRelation">
                      <span class="icon is-small is-left">
                  <font-awesome-icon :icon="['fas', 'arrows-spin']"/>
                </span>
                    </p>
                  </div>
                </div>
                <div class="column is-one-quarter has-text-left">
                  <label class="label has-text-centered"></label>
                  <div class="field is-narrow">
                    <div class="control">
                      <div class="fancy-input-group padded-checkboxes columns is-multiline is-vcentered">
                        <input v-bind:disabled="inputsDisabled" type="checkbox" name="guardianisnok" id="guardianisnok"
                               class="fancy-input" v-model="patientProfile.patientInfo.guardianIsNok"/>
                        <label for="guardianisnok" class="fancy-input-label column no-wrapping-label">Is next of
                          kin</label>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="column is-full top-border-input" v-if="!relationPicked.fetchGuardianRelations">
                  <div class="selection-list">
                    <div class="column is-full can-scroll-content">
                      <table class="table is-hoverable table is-fullwidth">
                        <tbody>
                        <tr>
                          <th class="has-text-centered">Relationship</th>
                          <th class="has-text-centered">Use</th>
                        </tr>
                        <tr v-for="(relationship, index) in relationshipsReturned.fetchGuardianRelations"
                            v-bind:key="index"
                            v-on:click="selectRelationship(relationship.relid,index,'fetchGuardianRelations')">
                          <td>{{ relationship.relation }}</td>
                          <td>
                            <font-awesome-icon :icon="['fas', 'hand-pointer']"/>
                          </td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>

              </div>
            </div>

            <div class="column is-full" v-if="nokBool || adultBool"></div>
            <div class="column is-full" v-if="nokBool || adultBool">
              <div id="personalThree" class="columns is-multiline is-vcentered section-box">
                <div class="column is-full section-box-title-column">
                  <div class="section-box-title-text">Next of Kin</div>
                </div>

                <div class="column is-full has-text-left bottom-border-input">
                  <label class="label has-text-centered">Next of Kin Name</label>
                  <div class="field">
                    <p class="control is-expanded has-icons-left">
                      <input v-bind:disabled="inputsDisabled" class="input input-no-top-margin" type="text"
                             placeholder="Name"
                             v-bind:class="{'error-input':v$.patientProfile.patientInfo.nok.$errors.length>0 && showErrors[0]}"
                             v-model="patientProfile.patientInfo.nok">
                      <span class="icon is-small is-left">
                  <font-awesome-icon :icon="['fas', 'user-check']"/>
                </span>
                    </p>
                  </div>
                </div>


                <div class="column is-half has-text-left bottom-border-input-mobile right-border-input">
                  <label class="label has-text-centered">Next of kin Phone Number</label>
                  <mobileNumberInput
                      v-bind:phoneContact="returnNokPhoneContact"
                      v-bind:countryPrefixError="v$.patientProfile.patientInfo.nokPhonePrefix.$errors.length>0 && showErrors[0]"
                      v-bind:phoneNumberError="v$.patientProfile.patientInfo.nokPhone.$errors.length>0 && showErrors[0]"
                      v-bind:countryName="currentData.country"
                      v-bind:textDataName="'Phone Number'"
                      v-bind:inputsDisabled="inputsDisabled"
                      v-on:phoneNumberProvided="setNokPhoneNumberData"
                  ></mobileNumberInput>
                </div>
                <div class="column is-half has-text-left">
                  <label class="label has-text-centered">Relationship</label>
                  <div class="field">
                    <p class="control is-expanded has-icons-left">
                      <input v-bind:disabled="inputsDisabled" class="input input-no-top-margin" type="text"
                             placeholder="Relationship"
                             v-bind:class="{'error-input':v$.patientProfile.patientInfo.nokRelation.$errors.length>0 && showErrors[0]}"
                             v-on:keyup="searchRelationship('fetchNokRelations')"
                             v-model="patientProfile.patientInfo.nokRelation">
                      <span class="icon is-small is-left">
                  <font-awesome-icon :icon="['fas', 'arrows-spin']"/>
                </span>
                    </p>
                  </div>
                </div>

                <div class="column is-full top-border-input" v-if="!relationPicked.fetchNokRelations">
                  <div class="selection-list">
                    <div class="column is-full can-scroll-content">
                      <table class="table is-hoverable table is-fullwidth">
                        <tbody>
                        <tr>
                          <th class="has-text-centered">Relationship</th>
                          <th class="has-text-centered">Use</th>
                        </tr>
                        <tr v-for="(relationship, index) in relationshipsReturned.fetchNokRelations" v-bind:key="index"
                            v-on:click="selectRelationship(relationship.relid,index,'fetchNokRelations')">
                          <td>{{ relationship.relation }}</td>
                          <td>
                            <font-awesome-icon :icon="['fas', 'hand-pointer']"/>
                          </td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>

              </div>
            </div>

            <div class="column is-full"></div>
            <div class="column is-full">
              <div id="personalFour" class="columns is-multiline is-vcentered section-box">
                <div class="column is-full section-box-title-column">
                  <div class="section-box-title-text">Origin</div>
                </div>

                <div class="column is-half has-text-left bottom-border-input right-border-input">
                  <label class="label has-text-centered">Smallest Administrative Unit
                  </label>
                  <div class="field">
                    <p class="control is-expanded has-icons-left">
                      <input v-bind:disabled="inputsDisabled" class="input input-no-top-margin" ref="smallestAdminUnit"
                             type="text"
                             placeholder="Administrative Unit"
                             v-bind:class="{'error-input':v$.patientProfile.patientInfo.patientLocation.$errors.length>0 && showErrors[0]}"
                             v-model="patientProfile.patientInfo.patientLocation"
                             v-on:keyup="searchLocation"
                      >
                      <span class="icon is-small is-left">
                  <font-awesome-icon :icon="['fas', 'street-view']"/>
                </span>
                    </p>
                  </div>
                </div>
                <div class="column is-half has-text-left bottom-border-input">
                  <label class="label has-text-centered">District</label>
                  <div class="field">
                    <p class="control is-expanded has-icons-left">
                      <input class="input input-no-top-margin" type="text" placeholder="District"
                             v-bind:class="{'error-input':v$.patientProfile.patientInfo.patientDistrict.$errors.length>0 && showErrors[0]}"
                             v-model="patientProfile.patientInfo.patientDistrict"
                             v-bind:disabled="districtEnabled || inputsDisabled">
                      <span class="icon is-small is-left">
                  <font-awesome-icon :icon="['fas', 'location-dot']"/>
                </span>
                    </p>
                  </div>
                </div>

                <div class="column is-full bottom-border-input" v-if="!locationPicked">
                  <div class="selection-list">
                    <div class="column is-full can-scroll-content">
                      <table class="table is-hoverable table is-fullwidth">
                        <tbody>
                        <tr>
                          <th class="has-text-centered">Location</th>
                          <th class="has-text-centered">District</th>
                          <th class="has-text-centered">Region</th>
                          <th class="has-text-centered">Use</th>
                        </tr>
                        <tr v-for="(location, index) in locationsReturned" v-bind:key="index"
                            v-on:click="selectLocation(location.id,index)">
                          <td>{{ location.location }}</td>
                          <td>{{ location.district }}</td>
                          <td>{{ location.region }}</td>
                          <td>
                            <font-awesome-icon :icon="['fas', 'hand-pointer']"/>
                          </td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>

                <div class="column is-half has-text-left bottom-border-input-mobile right-border-input">
                  <label class="label has-text-centered">Nearest Health Center</label>
                  <div class="field">
                    <p class="control is-expanded has-icons-left">
                      <input v-bind:disabled="inputsDisabled" class="input input-no-top-margin" type="text"
                             placeholder="Health Center"
                             v-bind:class="{'error-input':v$.patientProfile.patientInfo.closestHealthCenter.$errors.length>0 && showErrors[0]}"
                             v-model="patientProfile.patientInfo.closestHealthCenter">
                      <span class="icon is-small is-left">
                  <font-awesome-icon :icon="['fas', 'hospital']"/>
                </span>
                    </p>
                  </div>
                </div>
                <div class="column is-half has-text-left">
                  <label class="label has-text-centered">Referral From</label>
                  <div class="field">
                    <p class="control is-expanded has-icons-left">
                      <input v-bind:disabled="inputsDisabled" class="input input-no-top-margin" type="text"
                             placeholder="Referral From"
                             v-bind:class="{'error-input':v$.patientProfile.patientInfo.referralFrom.$errors.length>0 && showErrors[0]}"
                             v-model="patientProfile.patientInfo.referralFrom">
                      <span class="icon is-small is-left">
                  <font-awesome-icon :icon="['fas', 'hospital']"/>
                </span>
                    </p>
                  </div>
                </div>

              </div>
            </div>

            <div class="column is-full"></div>
            <div class="column is-full">
              <div id="personalFive" class="columns is-multiline is-vcentered section-box">
                <div class="column is-full section-box-title-column">
                  <div class="section-box-title-text">Privacy</div>
                </div>
                <div class="column is-full has-text-left"
                     v-bind:class="{'bottom-border-input':patientProfile.patientInfo.patientPrivacy==='privacyyes'}">
                  <label class="label has-text-centered">Has requested for privacy</label>
                  <div class="field is-narrow">
                    <div class="control">
                      <div class="fancy-input-group padded-checkboxes columns is-multiline is-vcentered"
                           v-bind:class="{'error-input':v$.patientProfile.patientInfo.patientPrivacy.$errors.length>0 && showErrors[0]}">
                        <input v-bind:disabled="inputsDisabled" type="radio" name="patientprivacy" id="privacyyes"
                               value="privacyyes" class="fancy-input"
                               v-model="patientProfile.patientInfo.patientPrivacy"/>
                        <label for="privacyyes" class="fancy-input-label column no-wrapping-label">Yes</label>
                        <input v-bind:disabled="inputsDisabled" type="radio" name="patientprivacy" id="privacyno"
                               value="privacyno" class="fancy-input"
                               v-model="patientProfile.patientInfo.patientPrivacy"/>
                        <label for="privacyno" class="fancy-input-label column no-wrapping-label">No</label>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="column is-full has-text-left"
                     v-if="patientProfile.patientInfo.patientPrivacy==='privacyyes'"
                >
                  <label class="label has-text-centered">Reason for privacy</label>
                  <div class="field">
                    <p class="control is-expanded">
                      <textarea class="textarea highlighted-input" placeholder="Reason for requesting privacy"
                                v-bind:class="{'error-input':v$.patientProfile.patientInfo.patientPrivacyReason.$errors.length>0 && showErrors[0]}"
                                v-model="patientProfile.patientInfo.patientPrivacyReason"
                                v-bind:disabled="disablePrivacyReason || inputsDisabled"></textarea>
                    </p>
                  </div>
                </div>

              </div>
            </div>

            <div class="column is-full">
              <h1 class="is-size-3 is-underlined">Social Economic</h1>
            </div>

            <div class="column is-full" v-if="memberAgeNumber !== '-'">
              The Patient is being considered <strong>{{ ageGroupName }}</strong> due to their age of
              <strong>{{ memberAgeNumber }}</strong> {{ memberAgeUnits }}.
            </div>

            <div class="column is-full"></div>
            <div class="column is-full">
              <div id="personalSix" class="columns is-multiline is-vcentered section-box">
                <div class="column is-full section-box-title-column">
                  <div class="section-box-title-text">Employment</div>
                </div>

                <div class="column is-full has-text-left"
                     v-bind:class="{'bottom-border-input':patientProfile.socialEconomic.profile !== 'patientunemployed' && patientProfile.socialEconomic.profile !== ''}">
                  <label class="label has-text-centered">Employment status of the {{ guardianText }}</label>
                  <div class="field is-narrow">
                    <div class="control">
                      <div class="fancy-input-group padded-checkboxes columns is-multiline is-vcentered"
                           v-bind:class="{'error-input':v$.patientProfile.socialEconomic.profile.$errors.length>0 && showErrors[0]}">
                        <input v-bind:disabled="inputsDisabled" type="radio" name="economicprofile" id="patientemployed"
                               value="patientemployed"
                               class="fancy-input" v-model="patientProfile.socialEconomic.profile"/>
                        <label for="patientemployed" class="fancy-input-label column no-wrapping-label">Employed</label>
                        <input v-bind:disabled="inputsDisabled" type="radio" name="economicprofile"
                               id="patientselfemployed" value="patientselfemployed"
                               class="fancy-input" v-model="patientProfile.socialEconomic.profile"/>
                        <label for="patientselfemployed" class="fancy-input-label column no-wrapping-label">Self
                          Employed</label>
                        <input v-bind:disabled="inputsDisabled" type="radio" name="economicprofile"
                               id="patientunemployed" value="patientunemployed"
                               class="fancy-input" v-model="patientProfile.socialEconomic.profile"/>
                        <label for="patientunemployed"
                               class="fancy-input-label column no-wrapping-label">Unemployed</label>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="column is-full has-text-left bottom-border-input"
                     v-if="patientProfile.socialEconomic.profile === 'patientselfemployed'"
                >
                  <label class="label has-text-centered">Nature of self employment</label>
                  <div class="field"
                       v-if="patientProfile.socialEconomic.profile === 'patientselfemployed'"
                  >
                    <p class="control is-expanded has-icons-left">
                      <input v-bind:disabled="inputsDisabled" class="input highlighted-input" type="text"
                             placeholder="Nature of self employment"
                             v-bind:class="{'error-input':v$.patientProfile.socialEconomic.profileDetails.$errors.length>0 && showErrors[0]}"
                             v-model="patientProfile.socialEconomic.profileDetails">
                      <span class="icon is-small is-left margined-icons">
                  <font-awesome-icon :icon="['fas', 'briefcase']"/>
                </span>
                    </p>
                  </div>

                </div>

                <div class="column is-full has-text-left bottom-border-input"
                     v-if="patientProfile.socialEconomic.profile === 'patientemployed'"
                >
                  <label class="label has-text-centered">Form of Employment of the {{ guardianText }}</label>
                  <div class="field is-narrow">
                    <div class="control">
                      <div class="fancy-input-group padded-checkboxes columns is-multiline is-vcentered"
                           v-bind:class="{'error-input':v$.patientProfile.socialEconomic.employmentForm.$errors.length>0 && showErrors[0]}">
                        <input type="radio" name="employmenttype" id="employmentformal" value="employmentformal"
                               class="fancy-input" v-bind:disabled="disableEmploymentForm || inputsDisabled"
                               v-model="patientProfile.socialEconomic.employmentForm"/>
                        <label for="employmentformal" class="fancy-input-label column no-wrapping-label">Formal</label>
                        <input type="radio" name="employmenttype" id="employmentinformal" value="employmentinformal"
                               class="fancy-input" v-bind:disabled="disableEmploymentForm || inputsDisabled"
                               v-model="patientProfile.socialEconomic.employmentForm"/>
                        <label for="employmentinformal"
                               class="fancy-input-label column no-wrapping-label">Informal</label>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="column is-full has-text-left bottom-border-input"
                     v-if="patientProfile.socialEconomic.profile === 'patientemployed'"
                >
                  <label class="label has-text-centered">Description of the employment</label>
                  <div class="field">
                    <p class="control is-expanded has-icons-left">
                      <input class="input highlighted-input" type="text" placeholder="Description of the employment"
                             v-bind:disabled="disableEmploymentForm || inputsDisabled"
                             v-bind:class="{'error-input':v$.patientProfile.socialEconomic.employmentFormDetails.$errors.length>0 && showErrors[0]}"
                             v-model="patientProfile.socialEconomic.employmentFormDetails">
                      <span class="icon is-small is-left margined-icons">
                  <font-awesome-icon :icon="['fas', 'building']"/>
                </span>
                    </p>
                  </div>
                </div>

                <div class="column is-full has-text-left"
                     v-if="hasSomeFormOfEmployment"
                >
                  <label class="label has-text-centered">Monthly income of the {{ guardianText }} (USD)</label>
                  <div class="field is-narrow">
                    <div class="control">
                      <div class="fancy-input-group padded-checkboxes columns is-multiline is-vcentered"
                           v-bind:class="{'error-input':v$.patientProfile.socialEconomic.monthlyIncome.$errors.length>0 && showErrors[0]}">
                        <input type="radio" name="monthlyincome" id="monthlyincomenone" value="monthlyincomenone"
                               class="fancy-input"
                               v-bind:disabled="disableMonthlyIncome || inputsDisabled"
                               v-model="patientProfile.socialEconomic.monthlyIncome"/>
                        <label for="monthlyincomenone" class="fancy-input-label column no-wrapping-label">None</label>
                        <input type="radio" name="monthlyincome" id="monthlyincome1_50" value="monthlyincome1_50"
                               class="fancy-input"
                               v-bind:disabled="disableMonthlyIncome || inputsDisabled"
                               v-model="patientProfile.socialEconomic.monthlyIncome"/>
                        <label for="monthlyincome1_50" class="fancy-input-label column no-wrapping-label">$1 -
                          $50</label>
                        <input type="radio" name="monthlyincome" id="monthlyincome51_100" value="monthlyincome51_100"
                               class="fancy-input"
                               v-bind:disabled="disableMonthlyIncome || inputsDisabled"
                               v-model="patientProfile.socialEconomic.monthlyIncome"/>
                        <label for="monthlyincome51_100" class="fancy-input-label column no-wrapping-label">$51 -
                          $100</label>
                        <input type="radio" name="monthlyincome" id="monthlyincome101_150" value="monthlyincome101_150"
                               class="fancy-input"
                               v-bind:disabled="disableMonthlyIncome || inputsDisabled"
                               v-model="patientProfile.socialEconomic.monthlyIncome"/>
                        <label for="monthlyincome101_150" class="fancy-input-label column no-wrapping-label">$101 -
                          $150</label>
                        <input type="radio" name="monthlyincome" id="monthlyincome151_200" value="monthlyincome151_200"
                               class="fancy-input"
                               v-bind:disabled="disableMonthlyIncome || inputsDisabled"
                               v-model="patientProfile.socialEconomic.monthlyIncome"/>
                        <label for="monthlyincome151_200" class="fancy-input-label column no-wrapping-label">$151 -
                          $200</label>
                        <input type="radio" name="monthlyincome" id="monthlyincome201_250" value="monthlyincome201_250"
                               class="fancy-input"
                               v-bind:disabled="disableMonthlyIncome || inputsDisabled"
                               v-model="patientProfile.socialEconomic.monthlyIncome"/>
                        <label for="monthlyincome201_250" class="fancy-input-label column no-wrapping-label">$201 -
                          $250</label>
                        <input type="radio" name="monthlyincome" id="monthlyincomeabove250"
                               value="monthlyincomeabove250"
                               class="fancy-input"
                               v-bind:disabled="disableMonthlyIncome || inputsDisabled"
                               v-model="patientProfile.socialEconomic.monthlyIncome"/>
                        <label for="monthlyincomeabove250" class="fancy-input-label column no-wrapping-label">Above
                          $250</label>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
            </div>

            <div class="column is-full"></div>
            <div class="column is-full">
              <div id="personalSeven" class="columns is-multiline is-vcentered section-box">
                <div class="column is-full section-box-title-column">
                  <div class="section-box-title-text">Housing</div>
                </div>

                <div class="column is-full has-text-left bottom-border-input">
                  <label class="label has-text-centered">Type of Housing</label>
                  <div class="field is-narrow">
                    <div class="control">
                      <div class="fancy-input-group padded-checkboxes columns is-multiline is-vcentered"
                           v-bind:class="{'error-input':v$.patientProfile.socialEconomic.housingType.$errors.length>0 && showErrors[0]}">
                        <input v-bind:disabled="inputsDisabled" type="radio" name="typeofhousing" id="typeofhousingmud"
                               value="typeofhousingmud"
                               class="fancy-input"
                               v-model="patientProfile.socialEconomic.housingType"/>
                        <label for="typeofhousingmud" class="fancy-input-label column no-wrapping-label">Mud
                          Built</label>
                        <input v-bind:disabled="inputsDisabled" type="radio" name="typeofhousing"
                               id="typeofhousingtimber" value="typeofhousingtimber"
                               class="fancy-input"
                               v-model="patientProfile.socialEconomic.housingType"/>
                        <label for="typeofhousingtimber" class="fancy-input-label column no-wrapping-label">Timber
                          Built</label>
                        <input v-bind:disabled="inputsDisabled" type="radio" name="typeofhousing"
                               id="typeofhousingironsheet"
                               value="typeofhousingironsheet"
                               class="fancy-input"
                               v-model="patientProfile.socialEconomic.housingType"/>
                        <label for="typeofhousingironsheet" class="fancy-input-label column no-wrapping-label">Iron
                          Sheet</label>
                        <input v-bind:disabled="inputsDisabled" type="radio" name="typeofhousing"
                               id="typeofhousingbrickstone"
                               value="typeofhousingbrickstone" class="fancy-input"
                               v-model="patientProfile.socialEconomic.housingType"/>
                        <label for="typeofhousingbrickstone"
                               class="fancy-input-label column no-wrapping-label">Brick/Stone</label>
                        <input v-bind:disabled="inputsDisabled" type="radio" name="typeofhousing"
                               id="typeofhousingother" value="typeofhousingother"
                               class="fancy-input"
                               v-model="patientProfile.socialEconomic.housingType"/>
                        <label for="typeofhousingother" class="fancy-input-label column no-wrapping-label">Other</label>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="column is-full has-text-left bottom-border-input"
                     v-if="patientProfile.socialEconomic.housingType==='typeofhousingother'">
                  <label class="label has-text-centered">Please specify the type of housing</label>
                  <div class="field is-narrow">
                    <p class="control is-expanded has-icons-left">
                      <input v-bind:disabled="inputsDisabled" class="input highlighted-input" type="text"
                             placeholder="Please specify the type of housing"
                             v-bind:class="{'error-input':v$.patientProfile.socialEconomic.housingTypeOther.$errors.length>0 && showErrors[0]}"
                             v-model="patientProfile.socialEconomic.housingTypeOther">
                      <span class="icon is-small is-left margined-icons">
                  <font-awesome-icon :icon="['fas', 'house-user']"/>
                </span>
                    </p>
                  </div>
                </div>

                <div class="column is-full has-text-left"
                     v-bind:class="{'bottom-border-input':patientProfile.socialEconomic.houseRooms==='numberofroomsthreeplus'}">
                  <label class="label has-text-centered">Number of rooms</label>
                  <div class="field is-narrow">
                    <div class="control">
                      <div class="fancy-input-group padded-checkboxes columns is-multiline is-vcentered"
                           v-bind:class="{'error-input':v$.patientProfile.socialEconomic.houseRooms.$errors.length>0 && showErrors[0]}">
                        <input v-bind:disabled="inputsDisabled" type="radio" name="numberofrooms" id="numberofroomsone"
                               value="numberofroomsone"
                               class="fancy-input"
                               v-model="patientProfile.socialEconomic.houseRooms"/>
                        <label for="numberofroomsone" class="fancy-input-label column no-wrapping-label">Single
                          Room</label>
                        <input v-bind:disabled="inputsDisabled" type="radio" name="numberofrooms" id="numberofroomstwo"
                               value="numberofroomstwo"
                               class="fancy-input"
                               v-model="patientProfile.socialEconomic.houseRooms"/>
                        <label for="numberofroomstwo" class="fancy-input-label column no-wrapping-label">Two
                          Rooms</label>
                        <input v-bind:disabled="inputsDisabled" type="radio" name="numberofrooms"
                               id="numberofroomsthree" value="numberofroomsthree"
                               class="fancy-input"
                               v-model="patientProfile.socialEconomic.houseRooms"/>
                        <label for="numberofroomsthree" class="fancy-input-label column no-wrapping-label">Three
                          Rooms</label>
                        <input v-bind:disabled="inputsDisabled" type="radio" name="numberofrooms"
                               id="numberofroomsthreeplus"
                               value="numberofroomsthreeplus"
                               class="fancy-input"
                               v-model="patientProfile.socialEconomic.houseRooms"/>
                        <label for="numberofroomsthreeplus" class="fancy-input-label column no-wrapping-label">More than
                          Three Rooms</label>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="column is-full has-text-left"
                     v-if="patientProfile.socialEconomic.houseRooms==='numberofroomsthreeplus'">

                  <label class="label has-text-centered">Please Specify number of rooms</label>
                  <div class="field is-narrow"
                       v-if="patientProfile.socialEconomic.houseRooms === 'numberofroomsthreeplus'"
                  >
                    <p class="control is-expanded has-icons-left">
                      <input v-bind:disabled="inputsDisabled" class="input highlighted-input" type="text"
                             placeholder="Please Specify number of rooms"
                             v-bind:class="{'error-input':v$.patientProfile.socialEconomic.houseRoomsOther.$errors.length>0 && showErrors[0]}"
                             v-model="patientProfile.socialEconomic.houseRoomsOther"
                             v-on:keydown="wholeNumbersOnly"
                             v-on:change="noNegativeValues('houseRoomsOther')">
                      <span class="icon is-small is-left margined-icons">
                  <font-awesome-icon :icon="['fas', 'house-user']"/>
                </span>
                    </p>
                  </div>
                </div>


              </div>
            </div>


            <div class="column is-full"></div>
            <div class="column is-full">
              <div id="personalEight" class="columns is-multiline is-vcentered section-box">
                <div class="column is-full section-box-title-column">
                  <div class="section-box-title-text">Energy</div>
                </div>

                <div class="column is-full has-text-left bottom-border-input">
                  <label class="label has-text-centered">The main source of power (Lighting)</label>
                  <div class="field is-narrow">
                    <div class="control">
                      <div class="fancy-input-group padded-checkboxes columns is-multiline is-vcentered"
                           v-bind:class="{'error-input':v$.patientProfile.socialEconomic.lightingEnergy.$errors.length>0 && showErrors[0]}">
                        <input v-bind:disabled="inputsDisabled" type="radio" name="mainsourceoflighting"
                               id="mainsourceoflightingelec"
                               value="mainsourceoflightingelec" class="fancy-input"
                               v-model="patientProfile.socialEconomic.lightingEnergy"/>
                        <label for="mainsourceoflightingelec"
                               class="fancy-input-label column no-wrapping-label">Electricity</label>
                        <input v-bind:disabled="inputsDisabled" type="radio" name="mainsourceoflighting"
                               id="mainsourceoflightingkero"
                               value="mainsourceoflightingkero" class="fancy-input"
                               v-model="patientProfile.socialEconomic.lightingEnergy"/>
                        <label for="mainsourceoflightingkero"
                               class="fancy-input-label column no-wrapping-label">Kerosene</label>
                        <input v-bind:disabled="inputsDisabled" type="radio" name="mainsourceoflighting"
                               id="mainsourceoflightingsolar"
                               value="mainsourceoflightingsolar" class="fancy-input"
                               v-model="patientProfile.socialEconomic.lightingEnergy"/>
                        <label for="mainsourceoflightingsolar"
                               class="fancy-input-label column no-wrapping-label">Solar</label>
                        <input v-bind:disabled="inputsDisabled" type="radio" name="mainsourceoflighting"
                               id="mainsourceoflightingother"
                               value="mainsourceoflightingother" class="fancy-input"
                               v-model="patientProfile.socialEconomic.lightingEnergy"/>
                        <label for="mainsourceoflightingother"
                               class="fancy-input-label column no-wrapping-label">Other</label>
                      </div>
                    </div>
                  </div>

                </div>

                <div class="column is-full has-text-left bottom-border-input"
                     v-if="patientProfile.socialEconomic.lightingEnergy==='mainsourceoflightingother'">
                  <label class="label has-text-centered">Please specify the main source of power (Lighting)</label>
                  <div class="field">
                    <p class="control is-expanded has-icons-left">
                      <input v-bind:disabled="inputsDisabled" class="input highlighted-input" type="text"
                             placeholder="Please specify the main source of power (Lighting)"
                             v-bind:class="{'error-input':v$.patientProfile.socialEconomic.lightingEnergyOther.$errors.length>0 && showErrors[0]}"
                             v-model="patientProfile.socialEconomic.lightingEnergyOther">
                      <span class="icon is-small is-left margined-icons">
                  <font-awesome-icon :icon="['fas', 'lightbulb']"/>
                </span>
                    </p>
                  </div>
                </div>

                <div class="column is-full has-text-left"
                     v-bind:class="{'bottom-border-input':patientProfile.socialEconomic.cookingEnergy==='mainsourceofcookingother'}">
                  <label class="label has-text-centered">The main source of energy (cooking)</label>
                  <div class="field is-narrow">
                    <div class="control">
                      <div class="fancy-input-group padded-checkboxes columns is-multiline is-vcentered"
                           v-bind:class="{'error-input':v$.patientProfile.socialEconomic.cookingEnergy.$errors.length>0 && showErrors[0]}">
                        <input v-bind:disabled="inputsDisabled" type="radio" name="mainsourceofcooking"
                               id="mainsourceofcookingelec"
                               value="mainsourceofcookingelec" class="fancy-input"
                               v-model="patientProfile.socialEconomic.cookingEnergy"/>
                        <label for="mainsourceofcookingelec"
                               class="fancy-input-label column no-wrapping-label">Electricity</label>
                        <input v-bind:disabled="inputsDisabled" type="radio" name="mainsourceofcooking"
                               id="mainsourceofcookingkero"
                               value="mainsourceofcookingkero" class="fancy-input"
                               v-model="patientProfile.socialEconomic.cookingEnergy"/>
                        <label for="mainsourceofcookingkero"
                               class="fancy-input-label column no-wrapping-label">Kerosene</label>
                        <input v-bind:disabled="inputsDisabled" type="radio" name="mainsourceofcooking"
                               id="mainsourceofcookingfirewood"
                               value="mainsourceofcookingfirewood"
                               class="fancy-input" v-model="patientProfile.socialEconomic.cookingEnergy"/>
                        <label for="mainsourceofcookingfirewood"
                               class="fancy-input-label column no-wrapping-label">Firewood</label>
                        <input v-bind:disabled="inputsDisabled" type="radio" name="mainsourceofcooking"
                               id="mainsourceofcookingcharcoal"
                               value="mainsourceofcookingcharcoal"
                               class="fancy-input" v-model="patientProfile.socialEconomic.cookingEnergy"/>
                        <label for="mainsourceofcookingcharcoal"
                               class="fancy-input-label column no-wrapping-label">Charcoal</label>
                        <input v-bind:disabled="inputsDisabled" type="radio" name="mainsourceofcooking"
                               id="mainsourceofcookinggas"
                               value="mainsourceofcookinggas" class="fancy-input"
                               v-model="patientProfile.socialEconomic.cookingEnergy"/>
                        <label for="mainsourceofcookinggas"
                               class="fancy-input-label column no-wrapping-label">Gas/Meko/Cooker</label>
                        <input v-bind:disabled="inputsDisabled" type="radio" name="mainsourceofcooking"
                               id="mainsourceofcookingother"
                               value="mainsourceofcookingother" class="fancy-input"
                               v-model="patientProfile.socialEconomic.cookingEnergy"/>
                        <label for="mainsourceofcookingother"
                               class="fancy-input-label column no-wrapping-label">Other</label>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="column is-full has-text-left"
                     v-if="patientProfile.socialEconomic.cookingEnergy==='mainsourceofcookingother'">
                  <label class="label has-text-centered">Please specify the main source of energy (cooking)</label>
                  <div class="field">
                    <p class="control is-expanded has-icons-left">
                      <input v-bind:disabled="inputsDisabled" class="input highlighted-input" type="text"
                             placeholder="Please specify the main source of energy (cooking)"
                             v-bind:class="{'error-input':v$.patientProfile.socialEconomic.cookingEnergyOther.$errors.length>0 && showErrors[0]}"
                             v-model="patientProfile.socialEconomic.cookingEnergyOther">
                      <span class="icon is-small is-left margined-icons">
                  <font-awesome-icon :icon="['fas', 'fire-flame-curved']"/>
                </span>
                    </p>
                  </div>
                </div>

              </div>
            </div>

            <div class="column is-full">
              <h1 class="is-size-3 is-underlined">Family</h1>
            </div>

            <div class="column is-full">
              <div id="personalNine" class="columns is-multiline is-vcentered section-box">
                <div class="column is-full section-box-title-column">
                  <div class="section-box-title-text">Household</div>
                </div>

                <div class="column is-full has-text-left bottom-border-input">
                  <label class="label has-text-centered">Number of household members the {{ guardianText }}
                    supports</label>
                  <div class="field is-narrow">
                    <div class="control">
                      <div class="fancy-input-group padded-checkboxes columns is-multiline is-vcentered"
                           v-bind:class="{'error-input':v$.patientProfile.family.householdSupported.$errors.length>0 && showErrors[0]}">
                        <input v-bind:disabled="inputsDisabled" type="radio" name="numberofdependants"
                               id="numberofdependantsself"
                               value="numberofdependantsself" class="fancy-input"
                               v-model="patientProfile.family.householdSupported"/>
                        <label for="numberofdependantsself" class="fancy-input-label column no-wrapping-label">Self
                          (1)</label>
                        <input v-bind:disabled="inputsDisabled" type="radio" name="numberofdependants"
                               id="numberofdependants2_5"
                               value="numberofdependants2_5" class="fancy-input"
                               v-model="patientProfile.family.householdSupported"/>
                        <label for="numberofdependants2_5" class="fancy-input-label column no-wrapping-label">2 to
                          5</label>
                        <input v-bind:disabled="inputsDisabled" type="radio" name="numberofdependants"
                               id="numberofdependants6_10"
                               value="numberofdependants6_10" class="fancy-input"
                               v-model="patientProfile.family.householdSupported"/>
                        <label for="numberofdependants6_10" class="fancy-input-label column no-wrapping-label">6 to
                          10</label>
                        <input v-bind:disabled="inputsDisabled" type="radio" name="numberofdependants"
                               id="numberofdependantsother"
                               value="numberofdependantsother" class="fancy-input"
                               v-model="patientProfile.family.householdSupported"/>
                        <label for="numberofdependantsother" class="fancy-input-label column no-wrapping-label">Over
                          10</label>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="column is-full has-text-left bottom-border-input"
                     v-if="patientProfile.family.householdSupported==='numberofdependantsother'">
                  <label class="label has-text-centered" v-html="householdDependentsPlaceholder"></label>
                  <div class="field">
                    <p class="control is-expanded has-icons-left">
                      <input v-bind:disabled="inputsDisabled" class="input highlighted-input" type="text"
                             v-bind:placeholder="householdDependentsPlaceholder"
                             v-bind:class="{'error-input':v$.patientProfile.family.householdSupportedDetails.$errors.length>0 && showErrors[0]}"
                             v-model="patientProfile.family.householdSupportedDetails"
                             v-on:keydown="wholeNumbersOnly"
                             v-on:change="noNegativeValues('householdSupportedDetails')">
                      <span class="icon is-small is-left margined-icons">
                  <font-awesome-icon :icon="['fas', 'people-group']"/>
                </span>
                    </p>
                  </div>
                </div>

                <div class="column is-full has-text-left">
                  <label class="label has-text-centered">Number of Children the {{ guardianText }} has</label>
                  <div class="field">
                    <p class="control is-expanded has-icons-left">
                      <input v-bind:disabled="inputsDisabled" class="input input-no-top-margin" type="text"
                             placeholder="Number of children"
                             v-bind:class="{'error-input':v$.patientProfile.family.childrenCount.$errors.length>0 && showErrors[0]}"
                             v-model="patientProfile.family.childrenCount"
                             v-on:keydown="wholeNumbersOnly"
                             v-on:change="noNegativeValues('childrenCount')">
                      <span class="icon is-small is-left">
                  <font-awesome-icon :icon="['fas', 'children']"/>
                </span>
                    </p>
                  </div>
                </div>

              </div>
            </div>
            <div class="column is-full"></div>

            <div class="column is-full" v-if="displayErrorsForTab('Personal Tab').length">
              <div id="AttachmentsSeven"
                   class="columns is-multiline is-vcentered section-box section-box-errors">
                <div class="column is-full section-box-title-column">
                  <div class="section-box-title-text section-box-title-text-error">Personal Tab Errors & Notices</div>
                </div>
                <div class="column is-full">
                  <p class="has-text-left"
                     v-for="error of displayErrorsForTab('Personal Tab')"
                     :key="error.uid"
                  ><strong class="strong-text-error">{{ error.message }}</strong>
                  </p>
                </div>
              </div>
            </div>
            <div class="column is-full" v-if="displayErrorsForTab('Personal Tab').length"></div>

            <div class="column is-full" v-if="blockNextButton!==''">
              <span v-html="blockNextButton"></span>
            </div>
            <div class="column is-full" v-if="blockNextButton!==''"></div>

          </div>
        </div>
      </TabContent>
      <TabContent title="Illness" ref="illnessTab" icon="fa fa-notes-medical">
        <div class="container">
          <div class="columns is-multiline is-vcentered">

            <div class="column is-full">
              <h1 class="is-size-3 is-underlined">Illness Profile</h1>
            </div>

            <div class="column is-full">
              <div id="illnessOne" class="columns is-multiline is-vcentered section-box">
                <div class="column is-full section-box-title-column">
                  <div class="section-box-title-text">Surgery</div>
                </div>

                <div class="column is-half has-text-left bottom-border-input right-border-input">
                  <label class="label has-text-centered">Condition</label>
                  <div class="field">
                    <p class="control is-expanded has-icons-left">
                      <input v-bind:disabled="inputsDisabled" class="input input-no-top-margin" type="text"
                             placeholder="Condition Suffered"
                             v-bind:class="{'error-input':v$.patientProfile.illnessProfile.condition.$errors.length>0 && showErrors[1]}"
                             v-model="patientProfile.illnessProfile.condition">
                      <span class="icon is-small is-left">
                  <font-awesome-icon :icon="['fas', 'circle-question']"/>
                </span>
                    </p>
                  </div>
                </div>
                <div class="column is-half has-text-left bottom-border-input">
                  <label class="label has-text-centered">Length of stay with condition</label>
                  <div class="field has-addons">
                    <p class="control is-expanded">
                      <input v-bind:disabled="inputsDisabled" class="input input-no-margin-top" type="text"
                             placeholder="Length of stay with condition"
                             v-bind:class="{'error-input':v$.patientProfile.illnessProfile.lengthOfCondition.$errors.length>0 && showErrors[1]}"
                             v-model.number="patientProfile.illnessProfile.lengthOfCondition"
                             v-on:keydown="wholeNumbersOnly"
                             v-on:change="noNegativeValues('lengthOfCondition')">
                    </p>
                    <p class="control">
                <span class="select">
                  <select v-bind:disabled="inputsDisabled" v-model="patientProfile.illnessProfile.lengthOfConditionUnit"
                          v-bind:class="{'error-input':v$.patientProfile.illnessProfile.lengthOfConditionUnit.$errors.length>0 && showErrors[1]}">
                    <option disabled value="">Select one</option>
                    <option value="minutes">Minutes</option>
                    <option value="hours">Hours</option>
                    <option value="days">Days</option>
                    <option value="weeks">Weeks</option>
                    <option value="months">Months</option>
                    <option value="years">Years</option>
                  </select>
                </span>
                    </p>
                  </div>
                </div>

                <div class="column is-half has-text-left bottom-border-input right-border-input">
                  <label class="label has-text-centered">Type</label>
                  <div class="field is-narrow">
                    <div class="control">
                      <div class="fancy-input-group padded-checkboxes columns is-multiline is-vcentered"
                           v-bind:class="{'error-input':v$.patientProfile.illnessProfile.surgeryType.$errors.length>0 && showErrors[1]}">
                        <input v-bind:disabled="inputsDisabled" type="radio" name="surgerytype" id="surgerytypeelective"
                               value="surgerytypeelective"
                               class="fancy-input"
                               v-model="patientProfile.illnessProfile.surgeryType"/>
                        <label for="surgerytypeelective"
                               class="fancy-input-label column no-wrapping-label">Elective</label>
                        <input v-bind:disabled="inputsDisabled" type="radio" name="surgerytype"
                               id="surgerytypeemergency" value="surgerytypeemergency"
                               class="fancy-input"
                               v-model="patientProfile.illnessProfile.surgeryType"/>
                        <label for="surgerytypeemergency"
                               class="fancy-input-label column no-wrapping-label">Emergency</label>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="column is-half has-text-left bottom-border-input">
                  <label class="label has-text-centered">Estimated Date of Surgery ({{ surgeryDateDiffDays }}
                    days)</label>
                  <div class="field" v-if="inputsDisabled">
                    <p class="control is-expanded has-icons-left">
                      <input class="input input-no-top-margin" type="text" placeholder=""
                             v-bind:value="displayDateOnly(patientProfile.illnessProfile.estDateOfSurgery)"
                             v-bind:disabled="inputsDisabled">
                      <span class="icon is-small is-left">
                  <font-awesome-icon :icon="['fas', 'calendar-days']"/>
                </span>
                    </p>
                  </div>
                  <div class="field" v-else>
                    <p class="control is-expanded has-icons-left">
                      <datepicker v-model="patientProfile.illnessProfile.estDateOfSurgery" name="surgerydate"
                                  v-bind:disabled-dates="surgeryDateConstrain"
                                  v-bind:clear-button="true"
                                  v-bind:input-class="'input-custom'"
                                  v-bind:wrapper-class="setDatePickerClassSurgeryDate"
                                  v-bind:calendar-class="'calendar-custom'"
                                  v-on:selected="surgeryDateSelected"></datepicker>
                    </p>

                  </div>
                </div>


                <div class="column is-half has-text-left bottom-border-input right-border-input"
                     v-if="patientProfile.illnessProfile.surgeryType==='surgerytypeemergency'">
                  <label class="label has-text-centered">Coordinator Notified</label>
                  <div class="field is-narrow">
                    <div class="control">
                      <div class="fancy-input-group padded-checkboxes columns is-multiline is-vcentered"
                           v-bind:class="{'error-input':v$.patientProfile.illnessProfile.coordinatorNotified.$errors.length>0 && showErrors[1]}">
                        <input v-bind:disabled="inputsDisabled" type="radio" name="coordinatornotified"
                               id="coordinatornotifiedyes"
                               value="coordinatornotifiedyes"
                               class="fancy-input"
                               v-model="patientProfile.illnessProfile.coordinatorNotified"/>
                        <label for="coordinatornotifiedyes"
                               class="fancy-input-label column no-wrapping-label">Yes</label>
                        <input v-bind:disabled="inputsDisabled" type="radio" name="coordinatornotified"
                               id="coordinatornotifiedno" value="coordinatornotifiedno"
                               class="fancy-input"
                               v-model="patientProfile.illnessProfile.coordinatorNotified"/>
                        <label for="coordinatornotifiedno"
                               class="fancy-input-label column no-wrapping-label">No</label>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="column is-half has-text-left bottom-border-input right-border-input"
                     v-if="patientProfile.illnessProfile.surgeryType==='surgerytypeemergency'">
                  <label class="label has-text-centered">Notification means</label>
                  <div class="field is-narrow">
                    <div class="control">
                      <div class="fancy-input-group padded-checkboxes columns is-multiline is-vcentered"
                           v-bind:class="{'error-input':v$.patientProfile.illnessProfile.coordinatorNotifiedMeans.$errors.length>0 && showErrors[1]}">
                        <input v-bind:disabled="inputsDisabled || coordinatorNotNotified" type="radio"
                               name="coordinatornotifiedmeans"
                               id="coordinatornotifiedmeanswhatsapp"
                               value="coordinatornotifiedmeanswhatsapp"
                               class="fancy-input"
                               v-model="patientProfile.illnessProfile.coordinatorNotifiedMeans"/>
                        <label for="coordinatornotifiedmeanswhatsapp"
                               class="fancy-input-label column no-wrapping-label">WhatsApp</label>
                        <input v-bind:disabled="inputsDisabled || coordinatorNotNotified" type="radio"
                               name="coordinatornotifiedmeans"
                               id="coordinatornotifiedmeanstext" value="coordinatornotifiedmeanstext"
                               class="fancy-input"
                               v-model="patientProfile.illnessProfile.coordinatorNotifiedMeans"/>
                        <label for="coordinatornotifiedmeanstext"
                               class="fancy-input-label column no-wrapping-label">Text</label>
                        <input v-bind:disabled="inputsDisabled || coordinatorNotNotified" type="radio"
                               name="coordinatornotifiedmeans"
                               id="coordinatornotifiedmeanscall" value="coordinatornotifiedmeanscall"
                               class="fancy-input"
                               v-model="patientProfile.illnessProfile.coordinatorNotifiedMeans"/>
                        <label for="coordinatornotifiedmeanscall"
                               class="fancy-input-label column no-wrapping-label">Call</label>
                        <input v-bind:disabled="inputsDisabled || coordinatorNotNotified" type="radio"
                               name="coordinatornotifiedmeans"
                               id="coordinatornotifiedmeansemail" value="coordinatornotifiedmeansemail"
                               class="fancy-input"
                               v-model="patientProfile.illnessProfile.coordinatorNotifiedMeans"/>
                        <label for="coordinatornotifiedmeansemail"
                               class="fancy-input-label column no-wrapping-label">Email</label>
                      </div>
                    </div>
                  </div>
                </div>


                <div class="column is-half has-text-left right-border-input bottom-border-input-mobile"
                     v-bind:class="{'bottom-border-input':patientProfile.illnessProfile.isCoPaying || surgeryHasGravidity || surgeryHasParity}">
                  <label class="label has-text-centered">Surgery required</label>
                  <div class="field">
                    <p class="control">
                <span class="select is-fullwidth">
                  <select v-bind:disabled="inputsDisabled" v-model="patientProfile.illnessProfile.surgeryRequired"
                          v-bind:class="{'error-input':v$.patientProfile.illnessProfile.surgeryRequired.$errors.length>0 && showErrors[1]}">
                    <option disabled value="">Select One</option>
                    <option v-for="(surgeryAvailable, index) in surgeriesAvailable"
                            v-bind:value="surgeryAvailable.surgery" v-bind:key="index">{{
                        surgeryAvailable.surgery
                      }}</option>

                  </select>
                </span>
                    </p>
                  </div>
                </div>
                <div class="column is-one-quarter has-text-left right-border-input bottom-border-input-mobile"
                     v-bind:class="{'bottom-border-input':patientProfile.illnessProfile.isCoPaying || surgeryHasGravidity || surgeryHasParity}">
                  <label class="label has-text-centered">Safe Ask</label>
                  <div class="safe-ask-amount">{{ patientProfile.illnessProfile.safeAskAmount }}</div>
                </div>
                <div class="column is-one-quarter has-text-left"
                     v-bind:class="{'bottom-border-input':patientProfile.illnessProfile.isCoPaying || surgeryHasGravidity || surgeryHasParity,
                     'bottom-border-input-mobile': surgeryHasGravidity || surgeryHasParity}">
                  <label class="label has-text-centered">&nbsp;</label>
                  <div class="field is-narrow">
                    <div class="control">
                      <div class="fancy-input-group padded-checkboxes columns is-multiline is-vcentered">
                        <input v-bind:disabled="inputsDisabled" type="checkbox" name="patientiscopaying"
                               id="patientiscopaying"
                               class="fancy-input" v-model="patientProfile.illnessProfile.isCoPaying"/>
                        <label for="patientiscopaying"
                               class="fancy-input-label column no-wrapping-label">Co-paying</label>
                      </div>
                    </div>
                  </div>
                </div>

                <!--                <div-->
                <!--                    class="column is-full bottom-border-input-mobile has-text-danger has-text-centered has-text-weight-bold"-->
                <!--                    v-if="surgeryWillAutoApprove"-->
                <!--                    v-bind:class="{'bottom-border-input':patientProfile.illnessProfile.isCoPaying || surgeryHasGravidity || surgeryHasParity}">-->
                <!--                  This surgery will auto-approve itself to enable immediate filling of the feedback.-->
                <!--                </div>-->


                <div class="column is-half has-text-left right-border-input bottom-border-input-mobile"
                     v-if="surgeryHasGravidity"
                     v-bind:class="{'bottom-border-input':patientProfile.illnessProfile.isCoPaying}">
                  <label class="label has-text-centered">Gravidity</label>
                  <div class="field">
                    <p class="control is-expanded has-icons-left">
                      <input v-bind:disabled="inputsDisabled" class="input input-no-top-margin" type="text"
                             placeholder="Gravidity"
                             v-bind:class="{'error-input':v$.patientProfile.illnessProfile.gravidity.$errors.length>0 && showErrors[1]}"
                             v-model="patientProfile.illnessProfile.gravidity"
                             v-on:keydown="wholeNumbersOnly"
                             v-on:change="noNegativeValues('gravidity')">
                      <span class="icon is-small is-left">
                  <font-awesome-icon :icon="['fas', 'person-pregnant']"/>
                </span>
                    </p>
                  </div>
                </div>
                <div class="column is-half has-text-left" v-if="surgeryHasParity"
                     v-bind:class="{'bottom-border-input':patientProfile.illnessProfile.isCoPaying}">
                  <label class="label has-text-centered">Parity</label>
                  <div class="field">
                    <p class="control is-expanded has-icons-left">
                      <input v-bind:disabled="inputsDisabled" class="input input-no-top-margin" type="text"
                             placeholder="Parity"
                             v-bind:class="{'error-input':v$.patientProfile.illnessProfile.parity.$errors.length>0 && showErrors[1]}"
                             v-model="patientProfile.illnessProfile.parity"
                             v-on:keydown="wholeNumbersOnly"
                             v-on:change="noNegativeValues('parity')">
                      <span class="icon is-small is-left">
                  <font-awesome-icon :icon="['fas', 'baby']"/>
                </span>
                    </p>
                  </div>
                </div>

                <coPaymentInputs
                    v-if="patientProfile.illnessProfile.isCoPaying"
                    v-bind:coPaymentData="returnCopaymentDataObj"
                    v-bind:insuranceProviderError="v$.patientProfile.illnessProfile.insuranceProvider.$errors.length>0 && showErrors[1]"
                    v-bind:OOPAmountError="copaymentRequired && showErrors[1]"
                    v-bind:InsAmountError="copaymentRequired && showErrors[1]"
                    v-bind:inputsDisabled="inputsDisabled"
                    v-on:coPaymentDataVal="coPaymentDataValReceived"
                ></coPaymentInputs>
              </div>
            </div>

            <div class="column is-full"></div>
            <div class="column is-full">
              <div id="illnessTwo" class="columns is-multiline is-vcentered section-box">
                <div class="column is-full section-box-title-column">
                  <div class="section-box-title-text">Transport</div>
                </div>
                <div class="column is-full has-text-left bottom-border-input">
                  <label class="label has-text-centered">Time taken to reach the hospital</label>
                  <div class="field has-addons">
                    <p class="control">
                      <input v-bind:disabled="inputsDisabled" class="input input-no-margin-top" type="text"
                             placeholder="Time taken to reach the hospital"
                             v-bind:class="{'error-input':v$.patientProfile.illnessProfile.timeToHospital.$errors.length>0 && showErrors[1]}"
                             v-model.number="patientProfile.illnessProfile.timeToHospital"
                             v-on:keydown="wholeNumbersOnly"
                             v-on:change="noNegativeValues('timeToHospital')">
                    </p>
                    <p class="control">
                <span class="select">
                  <select v-bind:disabled="inputsDisabled" v-model="patientProfile.illnessProfile.timeToHospitalUnits"
                          v-bind:class="{'error-input':v$.patientProfile.illnessProfile.timeToHospitalUnits.$errors.length>0 && showErrors[1]}">
                    <option disabled value="">Select One</option>
                    <option value="Minutes">Minutes</option>
                    <option value="Hours">Hours</option>
                    <option value="Days">Days</option>
                    <option value="Weeks">Weeks</option>
                  </select>
                </span>
                    </p>
                  </div>
                </div>
                <div class="column is-full has-text-left bottom-border-input">
                  <label class="label has-text-centered">Main mode of transport to the hospital</label>
                  <div class="field is-narrow">
                    <div class="control">
                      <div class="fancy-input-group padded-checkboxes columns is-multiline is-vcentered"
                           v-bind:class="{'error-input':v$.patientProfile.illnessProfile.transportation.$errors.length>0 && showErrors[1]}">
                        <input v-bind:disabled="inputsDisabled" type="radio" name="modeoftransporttohospital"
                               id="modeoftransporttohospitalwalk"
                               value="modeoftransporttohospitalwalk"
                               class="fancy-input"
                               v-model="patientProfile.illnessProfile.transportation"/>
                        <label for="modeoftransporttohospitalwalk"
                               class="fancy-input-label column no-wrapping-label">Walking</label>
                        <input v-bind:disabled="inputsDisabled" type="radio" name="modeoftransporttohospital"
                               id="modeoftransporttohospitalmotorcycle"
                               value="modeoftransporttohospitalmotorcycle"
                               class="fancy-input"
                               v-model="patientProfile.illnessProfile.transportation"/>
                        <label for="modeoftransporttohospitalmotorcycle"
                               class="fancy-input-label column no-wrapping-label">Motorcycle</label>
                        <input v-bind:disabled="inputsDisabled" type="radio" name="modeoftransporttohospital"
                               id="modeoftransporttohospitalpublicvehicle"
                               value="modeoftransporttohospitalpublicvehicle"
                               class="fancy-input"
                               v-model="patientProfile.illnessProfile.transportation"/>
                        <label for="modeoftransporttohospitalpublicvehicle"
                               class="fancy-input-label column no-wrapping-label">Public
                          Vehicle</label>
                        <input v-bind:disabled="inputsDisabled" type="radio" name="modeoftransporttohospital"
                               id="modeoftransporttohospitalprivatevehicle"
                               value="modeoftransporttohospitalprivatevehicle"
                               class="fancy-input"
                               v-model="patientProfile.illnessProfile.transportation"/>
                        <label for="modeoftransporttohospitalprivatevehicle"
                               class="fancy-input-label column no-wrapping-label">Private
                          Vehicle</label>
                        <input v-bind:disabled="inputsDisabled" type="radio" name="modeoftransporttohospital"
                               id="modeoftransporttohospitalother"
                               value="modeoftransporttohospitalother"
                               class="fancy-input"
                               v-model="patientProfile.illnessProfile.transportation"/>
                        <label for="modeoftransporttohospitalother" class="fancy-input-label column no-wrapping-label">Any
                          Other</label>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="column is-full has-text-left bottom-border-input"
                     v-if="patientProfile.illnessProfile.transportation==='modeoftransporttohospitalother'">
                  <label class="label has-text-centered">Main mode of transport used to get to the hospital</label>
                  <div class="field">
                    <p class="control is-expanded has-icons-left">
                      <input v-bind:disabled="inputsDisabled" class="input" type="text"
                             v-model="patientProfile.illnessProfile.transportationOther"
                             v-bind:class="{'error-input':v$.patientProfile.illnessProfile.transportationOther.$errors.length>0 && showErrors[1]}"
                             placeholder="Main mode of transport used to get to the hospital">
                      <span class="icon is-small is-left margined-icons">
                  <font-awesome-icon :icon="['fas', 'route']"/>
                </span>
                    </p>
                  </div>
                </div>

                <div class="column is-full has-text-left">
                  <label class="label has-text-centered">Amount spent on transport round trip</label>
                  <div class="field is-narrow">
                    <div class="control">
                      <div class="fancy-input-group padded-checkboxes columns is-multiline is-vcentered"
                           v-bind:class="{'error-input':v$.patientProfile.illnessProfile.transportationCost.$errors.length>0 && showErrors[1]}">
                        <input v-bind:disabled="inputsDisabled" type="radio" name="amountspentroundtrip"
                               id="amountspentroundtrip_under1"
                               value="amountspentroundtrip_under1"
                               class="fancy-input"
                               v-model="patientProfile.illnessProfile.transportationCost"/>
                        <label for="amountspentroundtrip_under1" class="fancy-input-label column no-wrapping-label">Under
                          $1</label>
                        <input v-bind:disabled="inputsDisabled" type="radio" name="amountspentroundtrip"
                               id="amountspentroundtrip1_5"
                               value="amountspentroundtrip1_5" class="fancy-input"
                               v-model="patientProfile.illnessProfile.transportationCost"/>
                        <label for="amountspentroundtrip1_5" class="fancy-input-label column no-wrapping-label">$1 -
                          $5</label>
                        <input v-bind:disabled="inputsDisabled" type="radio" name="amountspentroundtrip"
                               id="amountspentroundtrip6_10"
                               value="amountspentroundtrip6_10"
                               class="fancy-input"
                               v-model="patientProfile.illnessProfile.transportationCost"/>
                        <label for="amountspentroundtrip6_10" class="fancy-input-label column no-wrapping-label">$6 -
                          $10</label>
                        <input v-bind:disabled="inputsDisabled" type="radio" name="amountspentroundtrip"
                               id="amountspentroundtrip11_15"
                               value="amountspentroundtrip11_15"
                               class="fancy-input"
                               v-model="patientProfile.illnessProfile.transportationCost"/>
                        <label for="amountspentroundtrip11_15" class="fancy-input-label column no-wrapping-label">$11 -
                          $15</label>
                        <input v-bind:disabled="inputsDisabled" type="radio" name="amountspentroundtrip"
                               id="amountspentroundtrip16_20"
                               value="amountspentroundtrip16_20"
                               class="fancy-input"
                               v-model="patientProfile.illnessProfile.transportationCost"/>
                        <label for="amountspentroundtrip16_20" class="fancy-input-label column no-wrapping-label">$16 -
                          $20</label>
                        <input v-bind:disabled="inputsDisabled" type="radio" name="amountspentroundtrip"
                               id="amountspentroundtrip_above20"
                               value="amountspentroundtrip_above20"
                               class="fancy-input"
                               v-model="patientProfile.illnessProfile.transportationCost"/>
                        <label for="amountspentroundtrip_above20" class="fancy-input-label column no-wrapping-label">Above
                          $20</label>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
            </div>

            <div class="column is-full"></div>
            <div class="column is-full">
              <div id="illnessThree" class="columns is-multiline is-vcentered section-box">
                <div class="column is-full section-box-title-column">
                  <div class="section-box-title-text">Patient Story (Pre-OP)</div>
                </div>
                <div class="column is-full input-no-padding-top">
                  <div class="field">
                    <p class="control is-expanded">
                      <textarea v-bind:disabled="inputsDisabled" class="textarea" placeholder="Patient Story"
                                v-on:keyup="resize('patientStoryTextarea')"
                                ref="patientStoryTextarea"
                                v-bind:class="{'error-input':v$.patientProfile.illnessProfile.patientStory.$errors.length>0 && showErrors[1]}"
                                v-model.trim="patientProfile.illnessProfile.patientStory"></textarea>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div class="column is-full"></div>
            <div class="column is-full">
              <div id="illnessFour" class="columns is-multiline is-vcentered section-box">
                <div class="column is-full section-box-title-column">
                  <div class="section-box-title-text">Personal Quote (Pre-OP)</div>
                </div>
                <div class="column is-full input-no-padding-top">
                  <div class="field">
                    <p class="control is-expanded">
                      <textarea v-bind:disabled="inputsDisabled" class="textarea" placeholder="Personal Quote"
                                v-on:keyup="resize('personalQuoteTextarea')" ref="personalQuoteTextarea"
                                v-bind:class="{'error-input':v$.patientProfile.illnessProfile.patientQuote.$errors.length>0 && showErrors[1]}"
                                v-model.trim="patientProfile.illnessProfile.patientQuote"></textarea>
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div class="column is-full"></div>

            <div class="column is-full" v-if="displayErrorsForTab('Illness Tab').length">
              <div id="AttachmentsSeven"
                   class="columns is-multiline is-vcentered section-box section-box-errors">
                <div class="column is-full section-box-title-column">
                  <div class="section-box-title-text section-box-title-text-error">Illness Tab Errors & Notices</div>
                </div>
                <div class="column is-full">
                  <p class="has-text-left"
                     v-for="error of displayErrorsForTab('Illness Tab')"
                     :key="error.uid"
                  ><strong class="strong-text-error">{{ error.message }}</strong>
                  </p>
                </div>
              </div>
            </div>
            <div class="column is-full" v-if="displayErrorsForTab('Illness Tab').length"></div>
          </div>
        </div>
      </TabContent>
      <TabContent title="Attachments" ref="attachmentsTab" icon="fa fa-paperclip">
        <div class="container">
          <div class="columns is-multiline is-vcentered">
            <div class="column is-full">
              <h1 class="is-size-3 is-underlined">Patient Photo(s)</h1>
            </div>
            <div class="column is-full">
              <div id="AttachmentsOne" class="columns is-multiline is-vcentered section-box">
                <div class="column is-full section-box-title-column">
                  <div class="section-box-title-text">Note</div>
                </div>
                <div class="column is-full">
                  <p class="is-size-5 has-text-justified">The photo must show the patient’s face and be as positive and
                    dignified as
                    possible, Solid backgrounds (such as a painted wall) with natural light are best. If possible,
                    please
                    send multiple photos and we will select the best one.</p>
                  <p class="is-size-5 has-text-justified">Accepted file types: <strong>.pdf</strong>,
                    <strong>.jpg</strong>, <strong>.jpeg</strong>, <strong>.png</strong>
                  </p>
                </div>
              </div>
            </div>
            <div class="column is-full"></div>
            <div class="column is-full">
              <div id="AttachmentsTwo" class="columns is-multiline section-box">
                <div class="column is-full section-box-title-column">
                  <div class="section-box-title-text">Pre-OP Photos</div>
                </div>
                <div v-if="!patientProfile.profileTS">Please Complete the Personal and illness profiles</div>
                <div v-if="patientProfile.profileTS" class="column is-half"
                     v-bind:class="{'error-input':v$.patientProfile.confirmation.faceOne.$errors.length>0 && showErrors[2]}"
                >
                  <dropZone2Component
                      v-bind:id="`faceOne`"
                      v-bind:key="`faceOne`"
                      v-bind:fileIdentifier="`faceOne`"
                      v-bind:formName="`profile`"
                      v-bind:zoneTitle="'Image'"
                      v-bind:dataTs="patientProfile.profileTS"
                      v-bind:imageDataObj="patientProfile.confirmation.faceOne"
                      v-bind:acceptedFiles="'image/jpeg,image/png'"
                      v-bind:inputsDisabled="inputsDisabled"
                      v-on:dropZone2Emissions="dropZone2Emissions"
                  ></dropZone2Component>
                </div>
                <div v-if="patientProfile.profileTS" class="column is-half"
                     v-bind:class="{'error-input':v$.patientProfile.confirmation.faceTwo.$errors.length>0 && showErrors[2]}"
                >
                  <dropZone2Component
                      v-bind:id="`faceTwo`"
                      v-bind:key="`faceTwo`"
                      v-bind:fileIdentifier="`faceTwo`"
                      v-bind:formName="`profile`"
                      v-bind:zoneTitle="'Image'"
                      v-bind:dataTs="patientProfile.profileTS"
                      v-bind:imageDataObj="patientProfile.confirmation.faceTwo"
                      v-bind:acceptedFiles="'image/jpeg,image/png'"
                      v-bind:inputsDisabled="inputsDisabled"
                      v-on:dropZone2Emissions="dropZone2Emissions"
                  ></dropZone2Component>
                </div>
              </div>
            </div>

            <div class="column is-full"></div>
            <div class="column is-full">
              <div id="AttachmentsThree" class="columns is-multiline section-box">
                <div class="column is-full section-box-title-column">
                  <div class="section-box-title-text">Condition</div>
                </div>
                <div v-if="!patientProfile.profileTS">Please Complete the Personal and illness profiles</div>
                <div v-if="patientProfile.profileTS" class="column is-half">
                  <dropZone2Component
                      v-bind:id="`conditionOne`"
                      v-bind:key="`conditionOne`"
                      v-bind:fileIdentifier="`conditionOne`"
                      v-bind:formName="`profile`"
                      v-bind:zoneTitle="'Condition'"
                      v-bind:dataTs="patientProfile.profileTS"
                      v-bind:imageDataObj="patientProfile.confirmation.conditionOne"
                      v-bind:acceptedFiles="'image/jpeg,image/png'"
                      v-bind:inputsDisabled="inputsDisabled"
                      v-on:dropZone2Emissions="dropZone2Emissions"
                  ></dropZone2Component>
                </div>
                <div v-if="patientProfile.profileTS" class="column is-half">
                  <dropZone2Component
                      v-bind:id="`conditionTwo`"
                      v-bind:key="`conditionTwo`"
                      v-bind:fileIdentifier="`conditionTwo`"
                      v-bind:formName="`profile`"
                      v-bind:zoneTitle="'Condition'"
                      v-bind:dataTs="patientProfile.profileTS"
                      v-bind:imageDataObj="patientProfile.confirmation.conditionTwo"
                      v-bind:acceptedFiles="'image/jpeg,image/png'"
                      v-bind:inputsDisabled="inputsDisabled"
                      v-on:dropZone2Emissions="dropZone2Emissions"
                  ></dropZone2Component>
                </div>
              </div>
            </div>

            <div class="column is-full" v-if="expectingID"></div>
            <div class="column is-full" v-if="expectingID">
              <div id="AttachmentsFour" class="columns is-multiline section-box">
                <div class="column is-full section-box-title-column">
                  <div class="section-box-title-text">Identification Card</div>
                </div>
                <div v-if="!patientProfile.profileTS">Please Complete the Personal and illness profiles</div>
                <div v-if="patientProfile.profileTS" class="column is-half">
                  <dropZone2Component
                      v-bind:id="`IDFront`"
                      v-bind:key="`IDFront`"
                      v-bind:fileIdentifier="`IDFront`"
                      v-bind:formName="`profile`"
                      v-bind:zoneTitle="'ID Card'"
                      v-bind:dataTs="patientProfile.profileTS"
                      v-bind:imageDataObj="patientProfile.confirmation.IDFront"
                      v-bind:acceptedFiles="'application/pdf,image/jpeg,image/png'"
                      v-bind:inputsDisabled="inputsDisabled"
                      v-on:dropZone2Emissions="dropZone2Emissions"
                  ></dropZone2Component>
                </div>
                <div v-if="patientProfile.profileTS" class="column is-half">
                  <dropZone2Component
                      v-bind:id="`IDBack`"
                      v-bind:key="`IDBack`"
                      v-bind:fileIdentifier="`IDBack`"
                      v-bind:formName="`profile`"
                      v-bind:zoneTitle="'ID Card'"
                      v-bind:dataTs="patientProfile.profileTS"
                      v-bind:imageDataObj="patientProfile.confirmation.IDBack"
                      v-bind:acceptedFiles="'application/pdf,image/jpeg,image/png'"
                      v-bind:inputsDisabled="inputsDisabled"
                      v-on:dropZone2Emissions="dropZone2Emissions"
                  ></dropZone2Component>
                </div>
              </div>
            </div>


            <div class="column is-full" v-if="expectingPassport"></div>
            <div class="column is-full" v-if="expectingPassport">
              <div id="AttachmentsFive" class="columns is-multiline section-box">
                <div class="column is-full section-box-title-column">
                  <div class="section-box-title-text">Travellers Passport</div>
                </div>
                <div v-if="!patientProfile.profileTS">Please Complete the Personal and illness profiles</div>
                <div v-if="patientProfile.profileTS" class="column is-full">
                  <dropZone2Component
                      v-bind:id="`PassportBio`"
                      v-bind:key="`PassportBio`"
                      v-bind:fileIdentifier="`PassportBio`"
                      v-bind:formName="`profile`"
                      v-bind:zoneTitle="'Passport'"
                      v-bind:dataTs="patientProfile.profileTS"
                      v-bind:imageDataObj="patientProfile.confirmation.PassportBio"
                      v-bind:acceptedFiles="'application/pdf,image/jpeg,image/png'"
                      v-bind:inputsDisabled="inputsDisabled"
                      v-on:dropZone2Emissions="dropZone2Emissions"
                  ></dropZone2Component>
                </div>
                <div class="column is-half"></div>
              </div>
            </div>

            <div class="column is-full" v-if="expectingDl"></div>
            <div class="column is-full" v-if="expectingDl">
              <div id="AttachmentsSix" class="columns is-multiline section-box">
                <div class="column is-full section-box-title-column">
                  <div class="section-box-title-text">Driving Licence</div>
                </div>
                <div v-if="!patientProfile.profileTS">Please Complete the Personal and illness profiles</div>
                <div v-if="patientProfile.profileTS" class="column is-full">
                  <dropZone2Component
                      v-bind:id="`DLFace`"
                      v-bind:key="`DLFace`"
                      v-bind:fileIdentifier="`DLFace`"
                      v-bind:formName="`profile`"
                      v-bind:zoneTitle="'Driving Licence'"
                      v-bind:dataTs="patientProfile.profileTS"
                      v-bind:imageDataObj="patientProfile.confirmation.DLFace"
                      v-bind:acceptedFiles="'application/pdf,image/jpeg,image/png'"
                      v-bind:inputsDisabled="inputsDisabled"
                      v-on:dropZone2Emissions="dropZone2Emissions"
                  ></dropZone2Component>
                </div>
                <div class="column is-half"></div>
              </div>
            </div>

            <div class="column is-full"></div>
            <div class="column is-full">
              <div id="additionalAttachments" class="columns is-multiline is-vcentered section-box">
                <div class="column is-full section-box-title-column">
                  <div class="section-box-title-text">Additional Attachments</div>
                </div>
                <div v-if="!patientProfile.profileTS">Please Complete the Personal and illness profiles</div>
                <div v-if="patientProfile.profileTS" class="column is-one-quarter"
                     v-bind:class="{'error-input':v$.patientProfile.confirmation.waiverFile.$errors.length>0 && showErrors[2]}">
                  <dropZone2Component
                      v-bind:id="`waiverFile`"
                      v-bind:key="`waiverFile`"
                      v-bind:fileIdentifier="`waiverFile`"
                      v-bind:formName="`profile`"
                      v-bind:zoneTitle="'Waiver'"
                      v-bind:dataTs="patientProfile.profileTS"
                      v-bind:imageDataObj="patientProfile.confirmation.waiverFile"
                      v-bind:acceptedFiles="'application/pdf,image/jpeg,image/png'"
                      v-bind:inputsDisabled="inputsDisabled"
                      v-on:dropZone2Emissions="dropZone2Emissions"
                  ></dropZone2Component>
                </div>
                <div v-if="patientProfile.profileTS" class="column is-one-quarter">
                  <dropZone2Component
                      v-bind:id="`profileAttachment_1`"
                      v-bind:key="`profileAttachment_1`"
                      v-bind:fileIdentifier="`profileAttachment_1`"
                      v-bind:formName="`profile`"
                      v-bind:zoneTitle="'Attachment 1'"
                      v-bind:dataTs="patientProfile.profileTS"
                      v-bind:imageDataObj="patientProfile.confirmation.profileAttachment_1"
                      v-bind:acceptedFiles="'application/pdf,image/jpeg,image/png'"
                      v-bind:inputsDisabled="inputsDisabled"
                      v-on:dropZone2Emissions="dropZone2Emissions"
                  ></dropZone2Component>
                </div>
                <div v-if="patientProfile.profileTS" class="column is-one-quarter">
                  <dropZone2Component
                      v-bind:id="`profileAttachment_2`"
                      v-bind:key="`profileAttachment_2`"
                      v-bind:fileIdentifier="`profileAttachment_2`"
                      v-bind:formName="`profile`"
                      v-bind:zoneTitle="'Attachment 2'"
                      v-bind:dataTs="patientProfile.profileTS"
                      v-bind:imageDataObj="patientProfile.confirmation.profileAttachment_2"
                      v-bind:acceptedFiles="'application/pdf,image/jpeg,image/png'"
                      v-bind:inputsDisabled="inputsDisabled"
                      v-on:dropZone2Emissions="dropZone2Emissions"
                  ></dropZone2Component>
                </div>
                <div v-if="patientProfile.profileTS" class="column is-one-quarter">
                  <dropZone2Component
                      v-bind:id="`profileAttachment_3`"
                      v-bind:key="`profileAttachment_3`"
                      v-bind:fileIdentifier="`profileAttachment_3`"
                      v-bind:formName="`profile`"
                      v-bind:zoneTitle="'Attachment 3'"
                      v-bind:dataTs="patientProfile.profileTS"
                      v-bind:imageDataObj="patientProfile.confirmation.profileAttachment_3"
                      v-bind:acceptedFiles="'application/pdf,image/jpeg,image/png'"
                      v-bind:inputsDisabled="inputsDisabled"
                      v-on:dropZone2Emissions="dropZone2Emissions"
                  ></dropZone2Component>
                </div>
              </div>
            </div>

            <div class="column is-full"></div>
            <div class="column is-full">
              <div id="AttachmentsSeven" class="columns is-multiline is-vcentered section-box">
                <div class="column is-full section-box-title-column">
                  <div class="section-box-title-text">Checklist and Confirmation</div>
                </div>
                <div class="column is-full has-text-left bottom-border-input">
                  <label class="label has-text-left">Is the proposed treatment expected to save the patient’s life
                    or significantly increase their standard of living?</label>
                  <div class="field is-narrow">
                    <div class="control">
                      <div class="fancy-input-group padded-checkboxes columns is-multiline is-vcentered"
                           v-bind:class="{'error-input':v$.patientProfile.confirmation.treatmentchangelife.$errors.length>0 && showErrors[2]}">
                        <input v-bind:disabled="inputsDisabled" type="radio" name="treatmentchangelife"
                               id="treatmentchangelifeyes"
                               value="treatmentchangelifeyes" class="fancy-input"
                               v-model="patientProfile.confirmation.treatmentchangelife"/>
                        <label for="treatmentchangelifeyes"
                               class="fancy-input-label column no-wrapping-label">Yes</label>
                        <input v-bind:disabled="inputsDisabled" type="radio" name="treatmentchangelife"
                               id="treatmentchangelifeno"
                               value="treatmentchangelifeno" class="fancy-input"
                               v-model="patientProfile.confirmation.treatmentchangelife"/>
                        <label for="treatmentchangelifeno" class="fancy-input-label column no-wrapping-label">No</label>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="column is-full has-text-left">
                  <label class="label has-text-left">Do you agree to provide SAFE a complete treatment update within
                    30 days after the proposed treatment date listed in this form?</label>
                  <div class="field is-narrow">
                    <div class="control">
                      <div class="fancy-input-group padded-checkboxes columns is-multiline is-vcentered"
                           v-bind:class="{'error-input':v$.patientProfile.confirmation.treatmentupdate.$errors.length>0 && showErrors[2]}">
                        <input v-bind:disabled="inputsDisabled" type="radio" name="treatmentupdate"
                               id="treatmentupdateyes" value="treatmentupdateyes"
                               class="fancy-input"
                               v-model="patientProfile.confirmation.treatmentupdate"/>
                        <label for="treatmentupdateyes" class="fancy-input-label column no-wrapping-label">Yes</label>
                        <input v-bind:disabled="inputsDisabled" type="radio" name="treatmentupdate"
                               id="treatmentupdateno" value="treatmentupdateno"
                               class="fancy-input"
                               v-model="patientProfile.confirmation.treatmentupdate"/>
                        <label for="treatmentupdateno" class="fancy-input-label column no-wrapping-label">No</label>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="column is-full"></div>
              </div>

            </div>

            <div class="column is-full"></div>
            <div class="column is-full" v-if="v$.$errors.length">
              <div id="AttachmentsSeven"
                   class="columns is-multiline is-vcentered section-box section-box-errors">
                <div class="column is-full section-box-title-column">
                  <div class="section-box-title-text section-box-title-text-error">All Errors & Notices</div>
                </div>
                <div class="column is-full">
                  <p class="has-text-left"
                     v-for="error of v$.$errors"
                     :key="error.$uid">
                    <a href="#" v-on:click="goToErrorTab(error.$message)">
                      <strong class="strong-text-error">{{ error.$message }}</strong>
                    </a>
                  </p>
                </div>
              </div>
            </div>
            <div class="column is-full" v-if="v$.$errors.length"></div>
          </div>
        </div>
      </TabContent>
      <TabContent title="Summary" ref="summaryTab" icon="fa fa-clipboard-list">
        <div v-if="summaryAvailableBool && validationHasOccured" ref="summaryData">
          <div class="container">
            <div class="container">
              <div class="columns is-multiline is-vcentered">

                <div class="column is-full"></div>
                <div class="column is-full">
                  <div id="personalOne" class="columns is-multiline is-vcentered section-box">
                    <div class="column is-full section-box-title-column">
                      <div class="section-box-title-text">Case ID</div>
                    </div>
                    <div
                        class="column is-full has-text-left label-no-padding-top full-width-cell-last">
                      <label class="label has-text-centered">{{ summaryProfile.profileIdentifier }}</label>
                    </div>

                  </div>
                </div>

                <div class="column is-full">
                  <h1 class="is-size-3 is-underlined">Patient Information</h1>
                </div>

                <div class="column is-full">
                  <div id="personalOne" class="columns is-multiline is-vcentered section-box">
                    <div class="column is-full section-box-title-column">
                      <div class="section-box-title-text">Personal</div>
                    </div>
                    <div class="column is-full can-scroll-content">
                      <table class="table is-striped is-fullwidth">
                        <tbody>
                        <tr>
                          <td class="left-side-table-cell" colspan="2">
                            <label class="label has-text-left">Full Name</label>
                            <div class="has-text-centered">{{ summaryProfile.patientName }}</div>
                          </td>
                          <td class="right-side-table-cell" colspan="2">
                            <label class="label has-text-left">Patient Hospital Number</label>
                            <div class="has-text-centered">{{ summaryProfile.inpatientNumber }}</div>
                          </td>
                          <td class="right-side-table-cell" colspan="2">
                            <label class="label has-text-left">Patient Type</label>
                            <div class="has-text-centered">{{ summaryProfile.patientType }}</div>
                          </td>
                        </tr>
                        <tr>
                          <td class="left-side-table-cell" colspan="3">
                            <label class="label has-text-left">Gender</label>
                            <div class="has-text-centered">{{ summaryProfile.patientGender }}</div>
                          </td>
                          <td class="right-side-table-cell" colspan="3">
                            <label class="label has-text-left">Date of Birth</label>
                            <div class="has-text-centered">{{ summaryProfile.patientDob }}</div>
                          </td>
                        </tr>
                        <tr>
                          <td class="left-side-table-cell" colspan="3">
                            <label class="label has-text-left">Marital Status</label>
                            <div class="has-text-centered">{{ summaryProfile.patientMarital }}</div>
                          </td>
                          <td class="right-side-table-cell" colspan="3">
                            <label class="label has-text-left">Education Level</label>
                            <div class="has-text-centered">{{ summaryProfile.patientEducation }}</div>
                          </td>
                        </tr>
                        <tr>
                          <td class="left-side-table-cell" colspan="3">
                            <label class="label has-text-left">Patient Descriptor</label>
                            <div class="has-text-centered">{{ summaryProfile.patientDescription }}</div>
                          </td>
                          <td class="right-side-table-cell" colspan="3">
                            <label class="label has-text-left">Has Health Insurance</label>
                            <div class="has-text-centered">{{ summaryProfile.hasInsurance }}</div>
                          </td>
                        </tr>
                        <tr>
                          <td class="left-side-table-cell" colspan="3">
                            <label class="label has-text-left">Phone Number of the Patient</label>
                            <div class="has-text-centered">
                              {{ summaryProfile.patientPhoneNumber }}
                            </div>
                          </td>
                          <td class="right-side-table-cell" colspan="3">
                            <label class="label has-text-left">Government Identification</label>
                            <div class="has-text-centered">{{ summaryProfile.identificationDocument }}</div>
                          </td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>

                <div class="column is-full" v-if="summaryProfile.patientAgeGroup ==='Minor'"></div>
                <div class="column is-full" v-if="summaryProfile.patientAgeGroup ==='Minor'">
                  <div id="personalTwo" class="columns is-multiline is-vcentered section-box">
                    <div class="column is-full section-box-title-column">
                      <div class="section-box-title-text" v-if="summaryProfile.guardianIsNok==='No'">Guardian</div>
                      <div class="section-box-title-text" v-if="summaryProfile.guardianIsNok==='Yes'">Guardian and Next
                        of
                        Kin
                      </div>
                    </div>
                    <div class="column is-full can-scroll-content">
                      <table class="table is-striped is-fullwidth">
                        <tbody>
                        <tr>
                          <td colspan="2">
                            <label class="label has-text-left">Guardian Name</label>
                            <div class="has-text-centered">{{ summaryProfile.guardianName }}</div>
                          </td>
                        </tr>
                        <tr>
                          <td class="left-side-table-cell">
                            <label class="label has-text-left">Guardian Phone Number</label>
                            <div class="has-text-centered">
                              {{ summaryProfile.guardianPhone }}
                            </div>
                          </td>
                          <td class="right-side-table-cell">
                            <label class="label has-text-left">Relationship</label>
                            <div class="has-text-centered">{{ summaryProfile.guardianRelation }}</div>
                          </td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>

                <div class="column is-full"
                     v-if="summaryProfile.guardianIsNok==='No' || summaryProfile.patientAgeGroup ==='adult'"></div>
                <div class="column is-full"
                     v-if="summaryProfile.guardianIsNok==='No' || summaryProfile.patientAgeGroup ==='adult'">
                  <div id="personalThree" class="columns is-multiline is-vcentered section-box">
                    <div class="column is-full section-box-title-column">
                      <div class="section-box-title-text">Next of Kin</div>
                    </div>
                    <div class="column is-full can-scroll-content">
                      <table class="table is-striped is-fullwidth">
                        <tbody>
                        <tr>
                          <td colspan="2">
                            <label class="label has-text-left">Name</label>
                            <div class="has-text-centered">{{ summaryProfile.nextOfKinName }}</div>
                          </td>
                        </tr>
                        <tr>
                          <td class="left-side-table-cell">
                            <label class="label has-text-left">Phone Number</label>
                            <div class="has-text-centered">{{ summaryProfile.nextOfKinPhone }}</div>
                          </td>
                          <td class="right-side-table-cell">
                            <label class="label has-text-left">Relationship</label>
                            <div class="has-text-centered">{{ summaryProfile.nextOfKinRelation }}</div>
                          </td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>

                <div class="column is-full"></div>
                <div class="column is-full">
                  <div id="personalFour" class="columns is-multiline is-vcentered section-box">
                    <div class="column is-full section-box-title-column">
                      <div class="section-box-title-text">Origin</div>
                    </div>
                    <div class="column is-full can-scroll-content">
                      <table class="table is-striped is-fullwidth">
                        <tbody>
                        <tr>
                          <td colspan="2">
                            <label class="label has-text-left">Location and District of Origin</label>
                            <div class="has-text-centered">{{ summaryProfile.patientOrigin }}</div>
                          </td>
                        </tr>
                        <tr>
                          <td class="left-side-table-cell">
                            <label class="label has-text-left">Nearest Health Center</label>
                            <div class="has-text-centered">{{ summaryProfile.closestHealthCenter }}</div>
                          </td>
                          <td class="right-side-table-cell">
                            <label class="label has-text-left">Referral From</label>
                            <div class="has-text-centered">{{ summaryProfile.referralFrom }}</div>
                          </td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>

                <div class="column is-full"></div>
                <div class="column is-full">
                  <div id="personalFive" class="columns is-multiline is-vcentered section-box">
                    <div class="column is-full section-box-title-column">
                      <div class="section-box-title-text">Privacy</div>
                    </div>
                    <div class="column is-full can-scroll-content">
                      <table class="table is-striped is-fullwidth">
                        <tbody>
                        <tr>
                          <td colspan="2">
                            <label class="label has-text-left">Has requested for privacy</label>
                            <div class="has-text-centered" v-html="summaryProfile.patientPrivacy"></div>
                          </td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>

                <div class="column is-full">
                  <h1 class="is-size-3 is-underlined">Social Economic</h1>
                </div>

                <div class="column is-full">
                  <div id="personalSix" class="columns is-multiline is-vcentered section-box">
                    <div class="column is-full section-box-title-column">
                      <div class="section-box-title-text">Employment</div>
                    </div>
                    <div class="column is-full can-scroll-content">
                      <table class="table is-striped is-fullwidth">
                        <tbody>
                        <tr>
                          <td class="left-side-table-cell">
                            <label class="label has-text-left">Employment details of the {{
                                summaryProfile.patientOrGuardian
                              }}</label>
                            <div class="has-text-centered">
                              <strong>Profile: </strong>{{ summaryProfile.employmentProfile }}
                              <span v-if="summaryProfile.employmentType!=='-'"><br><strong>Type: </strong>{{
                                  summaryProfile.employmentType
                                }}</span>
                              <br><strong>Description: </strong>
                              <span v-if="summaryProfile.employmentDescription!=='-'">
                      {{ summaryProfile.employmentDescription }}
                    </span>
                              <span v-if="summaryProfile.selfemploymentDescription!=='-'">
                      {{ summaryProfile.selfemploymentDescription }}
                    </span>
                            </div>
                          </td>
                          <td class="right-side-table-cell">
                            <label class="label has-text-left">Monthly income of the {{
                                summaryProfile.patientOrGuardian
                              }}
                              (USD)</label>
                            <div class="has-text-centered">{{ summaryProfile.monthlyIncome }}</div>
                          </td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>

                <div class="column is-full"></div>
                <div class="column is-full">
                  <div id="personalSeven" class="columns is-multiline is-vcentered section-box">
                    <div class="column is-full section-box-title-column">
                      <div class="section-box-title-text">Housing</div>
                    </div>
                    <div class="column is-full can-scroll-content">
                      <table class="table is-striped is-fullwidth">
                        <tbody>
                        <tr>
                          <td class="left-side-table-cell">
                            <label class="label has-text-left">Type of Housing</label>
                            <div class="has-text-centered">{{ summaryProfile.housingType }}</div>
                          </td>
                          <td class="right-side-table-cell">
                            <label class="label has-text-left">Number of rooms</label>
                            <div class="has-text-centered">{{ summaryProfile.houseRooms }}</div>
                          </td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>

                <div class="column is-full"></div>
                <div class="column is-full">
                  <div id="personalEight" class="columns is-multiline is-vcentered section-box">
                    <div class="column is-full section-box-title-column">
                      <div class="section-box-title-text">Energy</div>
                    </div>
                    <div class="column is-full can-scroll-content">
                      <table class="table is-striped is-fullwidth">
                        <tbody>
                        <tr>
                          <td class="left-side-table-cell">
                            <label class="label has-text-left">The main source of power (Lighting)</label>
                            <div class="has-text-centered">{{ summaryProfile.lightingEnergy }}</div>
                          </td>
                          <td class="right-side-table-cell">
                            <label class="label has-text-left">The main source of energy (cooking)</label>
                            <div class="has-text-centered">{{ summaryProfile.cookingEnergy }}</div>
                          </td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>

                <div class="column is-full">
                  <h1 class="is-size-3 is-underlined">Family</h1>
                </div>

                <div class="column is-full">
                  <div id="personalNine" class="columns is-multiline is-vcentered section-box">
                    <div class="column is-full section-box-title-column">
                      <div class="section-box-title-text">Household</div>
                    </div>
                    <div class="column is-full can-scroll-content">
                      <table class="table is-striped is-fullwidth">
                        <tbody>
                        <tr>
                          <td class="left-side-table-cell">
                            <label class="label has-text-left">Number of household members the {{
                                summaryProfile.patientOrGuardian
                              }}
                              supports</label>
                            <div class="has-text-centered">{{ summaryProfile.supportingHouseHoldOf }}</div>
                          </td>
                          <td class="right-side-table-cell">
                            <label class="label has-text-left">Number of Children the {{
                                summaryProfile.patientOrGuardian
                              }}
                              has</label>
                            <div class="has-text-centered">{{ summaryProfile.numberOfChildren }}</div>
                          </td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
                <div class="column is-full"></div>
              </div>
            </div>
            <div class="container">
              <div class="columns is-multiline is-vcentered">
                <div class="column is-full">
                  <h1 class="is-size-3 is-underlined">Illness Profile</h1>
                </div>
                <div class="column is-full">
                  <div id="illnessOne" class="columns is-multiline is-vcentered section-box">
                    <div class="column is-full section-box-title-column">
                      <div class="section-box-title-text">Surgery</div>
                    </div>
                    <div class="column is-full can-scroll-content">
                      <table class="table is-striped is-fullwidth">
                        <tbody>
                        <tr>
                          <td class="left-side-table-cell" colspan="3">
                            <label class="label has-text-left">Condition</label>
                            <div class="has-text-centered">{{ summaryProfile.patientCondition }}</div>
                          </td>
                          <td class="right-side-table-cell" colspan="3">
                            <label class="label has-text-left">Length of stay with condition</label>
                            <div class="has-text-centered">{{ summaryProfile.timeWithCondition }}</div>
                          </td>
                        </tr>
                        <tr>
                          <td class="left-side-table-cell" colspan="2">
                            <label class="label has-text-left">Type</label>
                            <div class="has-text-centered">{{ summaryProfile.surgeryType }}</div>
                          </td>
                          <td class="middle-table-cell" colspan="2">
                            <label class="label has-text-left">Surgery required</label>
                            <div class="has-text-centered">{{ summaryProfile.surgeryRequired }}</div>
                          </td>
                          <td class="right-side-table-cell" colspan="2">
                            <label class="label has-text-left">Estimated Date of Surgery</label>
                            <div class="has-text-centered">{{ summaryProfile.estimatedSurgeryDay }}</div>
                          </td>
                        </tr>
                        <!--                        <tr v-if="summaryProfile.surgeryAutoApprove==='Yes'">-->
                        <!--                          <td class="" colspan="6">-->
                        <!--                            <label class="label has-text-danger has-text-centered has-text-weight-bold">This surgery-->
                        <!--                              will auto-approve itself to enable immediate filling of the feedback.</label>-->
                        <!--                          </td>-->
                        <!--                        </tr>-->
                        <tr>
                          <td class="left-side-table-cell" colspan="3">
                            <label class="label has-text-left">Coordinator Notified</label>
                            <div class="has-text-centered">{{ summaryProfile.coordinatorNotified }}</div>
                          </td>
                          <td class="right-side-table-cell" colspan="3">
                            <label class="label has-text-left">Notification Means</label>
                            <div class="has-text-centered">{{ summaryProfile.coordinatorNotifiedMeans }}</div>
                          </td>
                        </tr>
                        <tr>
                          <td class="left-side-table-cell" colspan="3">
                            <label class="label has-text-left">Gravidity</label>
                            <div class="has-text-centered">{{ summaryProfile.gravidity }}</div>
                          </td>
                          <td class="right-side-table-cell" colspan="3">
                            <label class="label has-text-left">Parity</label>
                            <div class="has-text-centered">{{ summaryProfile.parity }}</div>
                          </td>
                        </tr>
                        <tr>
                          <td class="left-side-table-cell" colspan="3">
                            <label class="label has-text-left">Safe Ask</label>
                            <div class="has-text-centered safe-ask-amount">{{ summaryProfile.safeAskAmount }}</div>
                          </td>
                          <td class="right-side-table-cell" colspan="3">
                            <label class="label has-text-left">Co-Payment Amount</label>
                            <div class="has-text-centered" v-html="summaryProfile.coPaymentDisplay"></div>
                          </td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>

                <div class="column is-full"></div>
                <div class="column is-full">
                  <div id="illnessTwo" class="columns is-multiline is-vcentered section-box">
                    <div class="column is-full section-box-title-column">
                      <div class="section-box-title-text">Transport</div>
                    </div>
                    <div class="column is-full can-scroll-content">
                      <table class="table is-striped is-fullwidth">
                        <tbody>
                        <tr>
                          <td class="left-side-table-cell">
                            <label class="label has-text-left">Time taken to reach the hospital</label>
                            <div class="has-text-centered">{{ summaryProfile.timeTakenToHospital }}</div>
                          </td>
                          <td class="middle-table-cell">
                            <label class="label has-text-left">Main mode of transport to the hospital</label>
                            <div class="has-text-centered">{{ summaryProfile.modeOfTransport }}</div>
                          </td>
                          <td class="right-side-table-cell">
                            <label class="label has-text-left">Amount spent on transport round trip</label>
                            <div class="has-text-centered">{{ summaryProfile.costOfTransport }}</div>
                          </td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>

                <div class="column is-full"></div>
                <div class="column is-full">
                  <div id="illnessThree" class="columns is-multiline is-vcentered section-box">
                    <div class="column is-full section-box-title-column">
                      <div class="section-box-title-text">Patient Story</div>
                    </div>
                    <div class="column is-full can-scroll-content">
                      <table class="table is-striped is-fullwidth">
                        <tbody>
                        <tr>
                          <td>
                            <div class="has-text-justified">{{ summaryProfile.patientStory }}</div>
                          </td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>

                <div class="column is-full"></div>
                <div class="column is-full">
                  <div id="illnessFour" class="columns is-multiline is-vcentered section-box">
                    <div class="column is-full section-box-title-column">
                      <div class="section-box-title-text">Personal Quote</div>
                    </div>
                    <div class="column is-full can-scroll-content">
                      <table class="table is-striped is-fullwidth">
                        <tbody>
                        <tr>
                          <td>
                            <div class="has-text-justified">{{ summaryProfile.patientQuote }}</div>
                          </td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
                <div class="column is-full"></div>
              </div>
            </div>
            <div class="container">
              <div class="columns is-multiline">

                <div class="column is-full">
                  <h1 class="is-size-3 is-underlined">Patient Photo(s)</h1>
                </div>

                <div class="column is-full" v-if="summaryProfile.faceImages.length!==0">
                  <div id="AttachmentsTwo" class="columns is-multiline is-vcentered section-box">
                    <div class="column is-full section-box-title-column">
                      <div class="section-box-title-text">Pre-OP Photos</div>
                    </div>
                    <div class="column is-half input-no-padding-top"
                         v-for="(faceImage, index) in summaryProfile.faceImages"
                         v-bind:key="index">
                      <div class="image-relative-container" v-on:click="previewURL('preop',index)">
                        <div class="image-flex-container">
                          <img v-bind:src="`${faceImage.thumbnail}`" alt="Patient Face"
                               class="image">
                        </div>
                        <div class="image-flex-container">Timestamp: <span>{{ faceImage.timestamp }}</span>
                        </div>
                        <div>Location:
                          <a v-bind:href="faceImage.location" target="_blank"
                             v-if="faceImage.location!==''">Here</a>
                          <span v-else></span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="column is-full" v-if="summaryProfile.conditionImages.length!==0"></div>
                <div class="column is-full" v-if="summaryProfile.conditionImages.length!==0">
                  <div id="AttachmentsThree" class="columns is-multiline is-vcentered section-box">
                    <div class="column is-full section-box-title-column">
                      <div class="section-box-title-text">Condition</div>
                    </div>
                    <div class="column is-half input-no-padding-top"
                         v-for="(conditionImage, index) in summaryProfile.conditionImages"
                         v-bind:key="index">
                      <div class="image-relative-container" v-on:click="previewURL('condition',index)">
                        <div class="image-flex-container">
                          <img v-bind:src="`${conditionImage.thumbnail}`" alt="Condition Image"
                               class="image">
                        </div>
                        <div class="image-flex-container">Timestamp: <span>{{
                            conditionImage.timestamp
                          }}</span></div>
                        <div>Location:
                          <a v-bind:href="conditionImage.location" target="_blank"
                             v-if="conditionImage.location!==''">Here</a>
                          <span v-else></span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="column is-full" v-if="summaryProfile.identificationImages.length!==0"></div>
                <div class="column is-full" v-if="summaryProfile.identificationImages.length!==0">
                  <div id="AttachmentsFour" class="columns is-multiline is-vcentered section-box">
                    <div class="column is-full section-box-title-column">
                      <div class="section-box-title-text">Identification Documents</div>
                    </div>
                    <div class="column is-half input-no-padding-top"
                         v-for="(identificationImage, index) in summaryProfile.identificationImages"
                         v-bind:key="index">
                      <div class="image-relative-container" v-on:click="previewURL('ids',index)">
                        <div class="image-flex-container">
                          <img v-bind:src="`${identificationImage.thumbnail}`" alt="Identification Image"
                               class="image">
                        </div>
                        <div class="image-flex-container">Timestamp: <span>{{
                            identificationImage.timestamp
                          }}</span>
                        </div>
                        <div>Location:
                          <a v-bind:href="identificationImage.location" target="_blank"
                             v-if="identificationImage.location!==''">Here</a>
                          <span v-else></span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="column is-full"></div>
                <div class="column is-full">
                  <div id="additionalAttachments" class="columns is-multiline is-vcentered section-box">
                    <div class="column is-full section-box-title-column">
                      <div class="section-box-title-text">Additional Attachments</div>
                    </div>
                    <div class="column is-one-quarter">
                      <div class="image-relative-container" v-on:click="previewURL('attachments',0)">
                        <div class="image-flex-container">
                          <img v-bind:src="`${summaryProfile.waiverImages[0].thumbnail}`" alt="Waiver"
                               class="image">
                        </div>
                      </div>
                    </div>
                    <div class="column is-one-quarter"
                         v-for="(additionalAttachment, index) in summaryProfile.additionalAttachments"
                         v-bind:key="index">
                      <div class="image-relative-container" v-on:click="previewURL('attachments',index+1)">
                        <div class="image-flex-container">
                          <img v-bind:src="`${additionalAttachment.thumbnail}`"
                               alt="Additional Attachment"
                               class="image">
                        </div>
                      </div>
                    </div>
                  </div>
                </div>


                <div class="column is-full"></div>
                <div class="column is-full">
                  <div id="AttachmentsSeven" class="columns is-multiline is-vcentered section-box">
                    <div class="column is-full section-box-title-column">
                      <div class="section-box-title-text">Checklist and Confirmation</div>
                    </div>
                    <div class="column is-full can-scroll-content">
                      <table class="table is-striped is-fullwidth">
                        <tbody>
                        <tr>
                          <td>
                            <label class="label has-text-left">Is the proposed treatment expected to save the patient’s
                              life
                              or significantly increase their standard of living?</label>
                            <div class="has-text-centered">{{ summaryProfile.treatmentChangeLife }}</div>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <label class="label has-text-left">Do you agree to provide SAFE a complete treatment update
                              within
                              30 days after the proposed treatment date listed in this form?</label>
                            <div class="has-text-centered">{{ summaryProfile.treatmentUpdate }}</div>
                          </td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
                <div class="column is-full"></div>

              </div>
            </div>
          </div>
        </div>
        <div class="container" v-if="!summaryAvailableBool && validationHasOccured">
          Please complete all form to view the summary
        </div>
      </TabContent>
    </FormWizard>
  </div>
  <div class="profile-form-container center-screen" v-if="profileSubmitted">
    <div class="columns is-multiline is-vcentered">
      <div class="column is-full">
        <a href="#" target="_blank" class="thumb fa fa-thumbs-up"></a>
        <div class="circle-wrap">
          <div class="circle-lg"></div>
        </div>
        <div class="dots-wrap">
          <div class="dot dot--t"></div>
          <div class="dot dot--tr"></div>
          <div class="dot dot--br"></div>
          <div class="dot dot--b"></div>
          <div class="dot dot--bl"></div>
          <div class="dot dot--tl"></div>
        </div>
      </div>
      <div class="column is-full" v-html="profileSubmittedMsg" style="margin-top: 60px"></div>
      <div class="column is-full">
        <button class='button is-fullwidth' v-on:click="closeProfileForm">OK</button>
      </div>
    </div>
  </div>
  <div class="profile-form-container center-screen" v-if="!currentDataLoaded">
    User Data loading...
  </div>
</template>

<style scoped>
@import "@/assets/fontawesome-free-6.5.2-web/css/all.min.css";

.profile-form-container {
  padding: 20px;
}

[v-cloak] {
  display: none;
}

.error-input {
  border: 1px solid red !important;
  background-color: #ffefef !important;
  opacity: 0.9 !important;
}

.margined-icons {
  margin-top: 20px;
}

.section-box {
  border: 1px solid black;
  padding: 5px;
  border-radius: 10px;
}

.section-box-errors {
  border-color: red !important;
}

.section-box-title-column {
  position: relative;
  top: -18px;
  padding: 0 !important;
  margin: 0 !important;
}

.section-box-title-text {
  background-color: white;
  padding: 0 5px;
  width: max-content;
  margin: 0 10px;
  border-radius: 5px;
}

.section-box-title-text-error {
  color: red !important;
}

.strong-text-error {
  color: red !important;
}

.safe-ask-amount {
  font-weight: bold;
  color: #4d9041;
  font-size: xx-large;
  line-height: 40px;
  text-align: center;
}

.wrapper-custom > div, .wrapper-custom > div > div#calendar-div {
  width: 100%;
}


.wrapper-custom div.vuejs3-datepicker__value {
  border: none;
  width: 100%;
  padding: 7px 0 0 0;
}

.wrapper-custom span.vuejs3-datepicker__clear-button {
  top: 7px;
}

.input-no-top-margin {
  margin-top: 0 !important;
}

.label-no-padding-bottom {
  padding-bottom: 0 !important;
}

.input-no-padding-top {
  padding-top: 0 !important;
}

.input-no-margin-top {
  margin-top: 0 !important;
}

.no-wrapping-label {
  white-space: nowrap;
}

.profile-form-container {
  padding: 20px;
}

.center-screen {
  position: absolute;
  top: 50%;
  left: 50%;
  margin-top: -50px;
  margin-left: -250px;
  width: 500px;
  height: 100px;
}

.highlighted-input {
}

.highlighted-text {
  font-weight: bold;
  font-size: xx-large;
}

.profilePostedText {
  font-weight: bold;
  font-size: xxx-large;
}

@media screen and (max-width: 768px) {

  .field.has-addons,
  .field.is-grouped {
    display: block !important;

    .control:not(:last-child) {
      margin-right: 0 !important;
      margin-bottom: 1em !important;

      button {
        width: 100% !important;
      }
    }
  }

  .right-border-input {
    border-right: none;
  }

  .bottom-border-input-mobile {
    border-bottom: 1px solid black;
  }
}

@media screen and (min-width: 769px) {
  .bottom-border-input-mobile {
    border-bottom: none;
  }

  .right-border-input {
    border-right: 1px solid black;
  }
}

.can-scroll-content {
  overflow-x: scroll;
}

.bottom-border-input {
  border-bottom: 1px solid black;
}

.top-border-input {
  border-top: 1px solid black;
}


.padded-checkboxes {
  padding: 12px;
}
</style>
